export const enLangDashboard = {
  common: {
    you: 'You',
    post: 'Post',
    article: 'Article',
    create: 'Create',
    message: 'Message',
    popular: 'Popular',
    emptyIntegrations: 'You need to add integrations first',
    categories: 'Categories',
    edit: 'Edit',
    share: 'Share',
    plan: 'Plan',
    sort: 'Sort',
    addArticle: 'Add article',
    articles: 'Articles',
    users: 'users',
    scans: 'scans',
    clicks: 'clicks',
    copy: 'Copy',
    customize: 'Customize',
    link: 'link',
    save: 'Save',
    uploadFile: 'Upload File',
    customImage: 'Custom Image',
    customImageTooltip: 'Upload custom image',
    size: 'Size',
    sizeTooltip: 'Drag slider to set size',
    auto: 'Auto',
    rectangle: 'Rectangle',
    custom: 'Custom',
    clean: 'Clean',
    cleaning: 'Cleaning',
    download: 'Download',
    downloading: 'Downloading',
    preview: 'PREVIEW',
    cover: 'Cover',
    coverTooltip: 'Upload a cover photo',
    title: 'Title',
    new: 'New',
    pro: 'Pro',
    free: 'Free',
    limit: 'Limit',
    websites: 'websites',
    site: 'Site',
    apiKey: 'API Key',
    name: 'Name',
    passwordChange: 'Password change',
    draft: 'Draft',
    page: 'Page',
    areYouSure: 'Are you sure?',
    drop: 'Drop',
    video: 'video',
    image: 'image',
    chooseFile: 'Choose file',
    nothingFound: 'Nothing Found',
    enterCorrectLink: 'Enter correct link',
    off: 'Off',
    disconnect: 'DISCONNECT',
    connect: 'CONNECT',
    copied: 'Copied',
    saved: 'Saved',
    lostConnection: 'Lost connection',
    addedCategory: 'Added category',
    none: 'None',
    left: 'Left',
    right: 'Right',
    solid: 'Solid',
    double: 'Double',
    welcome: 'Welcome',
    category: 'Category',
    product: 'Product',
    website: 'Website',
    items: 'Items',
    square: 'Square',
    round: 'Round',
    border: 'Border',
    shadow: 'Shadow',
    soft: 'Soft',
    hard: 'Hard',
    block: 'Block',
    primary: 'Primary',
    additional: 'Additional',
    normal: 'Normal',
    bold: 'Bold',
    uploadVideo: 'Upload video',
    compact: 'Compact',
    card: 'Card',
    top: 'Top',
    center: 'Center',
    bottom: 'Bottom',
    button: 'Button',
    addNewItem: 'Add new item',
    price: 'Price',
    priceCaption: 'Add price of your product',
    oldPrice: 'Old price',
    oldPriceCaption: 'Old price will be strikethrough',
    areYouSureDeleteItem: 'Are you sure you want to remove this item?',
    add: 'Add',
    active: 'Active',
    isActive: 'is active',
    isDisabled: 'is disabled',
    uploadImage: 'Upload image',
    design: 'Design',
    addAccount: 'Add account',
    hey: 'Hey',
    activeBackground: 'Active background',
    activeText: 'Active text',
    connectDomain: 'Connect Domain',
    shortLink: 'Short Link',
    appearanceSaved: 'Appearance saved!',
    blockAdded: 'Block added!',
    comingSoon: 'Coming soon',
    easyMoney: 'Easy money',
    content: 'Content',
    audience: 'Audience',
    view: 'View',
    delete: 'Delete',
    file: 'File',
    type: 'Type',
    from: 'From',
    to: 'To',
    fullName: 'Full name',
    lastTimeUsed: 'Last time used',
    noMediaFiles: 'No media files yet...',
    withdraw: 'Withdraw',
    congrats: 'Congrats!',
    makeMoneyOnline: 'Make money online!',
  },
  sort: {
    title: 'Sort',
    search: 'Search',
    default: 'Default sorting',
    dateNew: 'Date: Newest to Oldest',
    dateOld: 'Date: Oldest to Newest',
    priceLow: 'Price: Low to High',
    priceHigh: 'Price: High to Low',
    nameA: 'Name: A to Z',
    nameZ: 'Name: Z to A',
  },
  sort: {
    title: 'Sort',
    search: 'Search',
    default: 'Default sorting',
    dateNew: 'Date: Newest to Oldest',
    dateOld: 'Date: Oldest to Newest',
    priceLow: 'Price: Low to High',
    priceHigh: 'Price: High to Low',
    nameA: 'Name: A to Z',
    nameZ: 'Name: Z to A',
  },
  emailMenu: {
    broadcasts: 'Broadcasts',
    automations: 'Automations',
    templates: 'Templates',
    settings: 'Settings',
    noEmails: 'No emails yet',
    newBroadcast: 'New Broadcasts',
  },
  aiContent: {
    title: 'Create your first content AI!',
    text: 'Plan and publish content to all social media at once!',
    create: 'Create content AI',
  },
  pageDesign: {
    page: 'Page design',
    image: 'Image',
  },
  toolsMenu: {
    title: 'Tools',
    account: 'Account',
    instantPages: 'Instant Pages',
    instantPagesText: 'Fast-loading standalone pages',
    agents: 'Agents',
    agentsText: 'AI assistants that manage your profile',
    socialPlanner: 'Social Planner',
    socialPlannerText: 'Content scheduling and inspiration',
    emailMarketing: 'Email Marketing',
    emailMarketingText: 'Grow your list of contacts',
    smartReply: 'Smart Reply',
    smartReplyText: 'Send automated comments & messages',
    linkShortener: 'Short Links',
    linkShortenerText: 'Make long URLs shorter',
    posts: 'Posts',
    postsText: 'Create and manage posts',
    blog: 'Blog',
    blogText: 'Create and manage blog articles',
  },
  insideMenu: {
    planner: 'Planner',
    aiContent: 'AI Content',
    aiPosts: 'AI Posts',
    postIdeas: 'Post Ideas',
    contentPlanner: 'Content Planner',
    aiImages: 'AI Images',
    brandProjects: 'Brand Projects',
    aiVideo: 'AI Video',
    integrations: 'Integrations',
    products: 'Products',
    orders: 'Orders',
    payments: 'Payments',
    links: 'Links',
    qrCodes: 'QR Codes',
  },
  orders: {
    title: 'Orders',
    empty: "You don't have any orders yet",
    all: 'All orders',
    shop: 'Shop',
    digital: 'Digital products',
    appointments: 'Appointments',
    services: 'Services',
    donations: 'Donations',
  },
  discounts: {
    title: 'Discounts',
    newDiscount: '+ New Discount',
    code: 'Code',
    titleCol: 'Title',
    type: 'Type',
    value: 'Value',
    status: 'Status',
    used: 'Used',
    actions: 'Actions',
    statusAll: 'All statuses',
    statusActive: 'Active',
    statusExpired: 'Expired',
    statusScheduled: 'Scheduled',
    statusInactive: 'Inactive',
    searchPlaceholder: 'Search by code or title...',
    clearFilters: 'Clear filters',
    emptyTitle: 'No discounts yet',
    emptySubtitle: 'Create your first promo code to offer discounts on your products',
    createDiscount: 'Create Discount',
    createTitle: 'Create Discount',
    editTitle: 'Edit Discount',
    fieldTitle: 'Title',
    fieldTitlePlaceholder: 'e.g. Spring Sale',
    fieldCode: 'Code',
    fieldCodePlaceholder: 'e.g. SAVE20',
    generate: 'Generate',
    sectionDiscount: 'Discount',
    fieldType: 'Type',
    typePercentage: 'Percentage',
    typeFixed: 'Fixed amount',
    typeFreeShipping: 'Free shipping',
    fieldValue: 'Value',
    sectionConditions: 'Conditions (optional)',
    appliesTo: 'Applies to',
    appliesToAll: 'All products',
    appliesToShop: 'Shop',
    appliesToDigital: 'Digital',
    appliesToCourses: 'Courses',
    appliesToServices: 'Services',
    appliesToEvents: 'Events',
    minOrderAmount: 'Min order amount ($)',
    maxDiscountAmount: 'Max discount amount ($) — 0 = no limit',
    minItemCount: 'Min items in order — 0 = no requirement',
    specificProducts: 'Specific products — empty = all eligible',
    specificProductsPlaceholder: 'Search products...',
    noProductsFound: 'No products found',
    sectionLimits: 'Limits',
    usageLimit: 'Total usage limit — 0 = unlimited',
    usageLimitPerUser: 'Per customer limit — 0 = unlimited',
    sectionSchedule: 'Schedule',
    startDate: 'Start date — empty = starts now',
    endDate: 'End date — empty = no expiry',
    active: 'Active',
    cancel: 'Cancel',
    save: 'Save Discount',
    createdSuccess: 'Discount created',
    updatedSuccess: 'Discount updated',
    deletedSuccess: 'Discount deleted',
    loadError: 'Failed to load discounts',
    saveError: 'Failed to save discount',
    deleteError: 'Failed to delete discount',
  },
  donation: {
    chooseSmiles: 'Choose smiles',
    item: 'Item',
    itemTitle: 'Title of donation item',
    price: 'Price',
    thanksMessagePlaceholder: 'Thank you very much',
    thanksMessage: 'Thanks message',
    thanksMessageCaption: 'Thanks message will show to your fans after donation',
    addDonation: 'Add donation',
    addAmount: '+ Add amount',
    buttonTitle: 'Button title',
    buttonTitleCaption: 'Title of donation button',
    acceptDonations: 'Accept donations',
    donationsType: 'Donations',
    tips: 'Tips',
    type: 'Type',
    addAnotherAmount: '+ Add another amount',
  },
  blog: {
    empty: "You don't have blog yet",
  },
  apps: {
    empty: "You don't have apps yet",
  },
  payments: {
    title: 'Payments',
    text: 'You don`t have any transaction yet',
    single: 'Single payments',
    subscriptions: 'Subscriptions',
    wallet: 'Wallet',
    connectPromo: 'Connect Stripe or PayPal account to your UniLink page and receive all payments to your wallet.',
    connectSystem: 'Connect payment system',
    manageCards: 'Manage your cards',
    addNewCard: 'Add new card',
    editCard: 'Edit card info',
    addCard: 'Add card info',
    cardHolder: 'Card Holder Name',
    cardHolderNecessary: 'It is nececessary',
    withdrawalSuccess: 'Your withdraw was successfully submitted!',
    withdrawalError: 'Something went wrong, try again later.',
    change: 'Change',
  },
  store: {
    emptyTitle: 'You don’t have any products yet',
    emptyText: 'Start by adding your first product',
    emptyButton: 'Add product',

    createFirstProduct: 'Create your first product',
    startAdding: 'Start by adding your favorite products, digital goods, or services. A space where you can sell and promote everything you offer.',
    activate: 'Activate Store',
    empty: "You don't have products yet",
    products: 'Products',
    addProducts: 'Add products',
    whatDoYouWant: 'What do you want to sell?',
    externalProduct: 'External product URL',
    createOwnProduct: 'Create your own product',

    shop: 'Shop',
    shopText: 'Sell physical and digital products',
    digital: 'Digital products',
    digitalText: 'Sell a Digital Download',
    course: 'Course or Tutorial',
    courseText: 'Add course or tutorial to the website',
    service: 'Services',
    serviceText: 'Add services from your customers',
    appointment: 'Appointments',
    appointmentText: 'Let visitors book time on your calendar',
    event: 'Events or Tickets',
    eventText: 'Create event and invite audience',
    tips: 'Tips',
    tipsText: 'Leave a tip for your favorite creators',
    donation: 'Donations',
    donationText: 'Make a donation',
    membership: 'Membership',
    membershipText: 'Add membership to the website',
    links: 'External link',
    linksText: 'Add external link to any websites',
    coupon: 'Coupon',
    couponText: 'Add coupon for your website',
    singleProduct: 'Single Product',
    singleProductText: 'Sell a single product with a simple checkout',
    booking: 'Booking',
    bookingText: 'Let visitors book your spaces or properties',
    rental: 'Rental',
    rentalText: 'List rental items with availability and pricing',

    add: 'Add',
    manageStore: 'Manage Store',
    displayLast: 'Display last product',
  },
  products: {
    info: 'Info',
    uploadCover: 'Upload a cover photo, then provide a title and description',
    thumbnail: 'Thumbnail',
    thumbnailError: 'Please add a thumbnail',
    title: 'Title',
    titleTooltip: 'Enter name of your product',
    shortDescription: 'Short description',
    shortDescriptionTooltip: 'Enter short description of your product',
    description: 'Description',
    descriptionTooltip: 'Enter description of your product',
    descriptionTooltipExtra: 'Optional description of product features, types, color, sizes, etc.',
    price: 'Price',
    priceTooltip: 'Enter price of your product',
    oldPrice: 'Old price',
    oldPriceTooltip: 'Old price will be strikethrough',
    category: 'Category',
    categoryTooltip: 'Choose category of your product',
    image: 'Image',
    imageTooltip: 'Upload image for your product',
    groups: 'Groups',
    rate: 'Rate',
    rateTooltip: 'Enter rate of your product',
    buttonTitle: 'Button title',
    buttonTitleTooltip: 'Enter title of your product button',
    limitQuantity: 'Limit Quantity',
    itemsLeft: 'Items left',
    itemsLeftTooltip: 'Items of your product',
    attachments: 'Attachments',
    addAttachments: 'Add attachments to your products',
    addNewAttachment: 'Add new item',
    file: 'File',
    uploadFile: 'Upload file',
    uploadCoverTitle: 'Upload cover',
    optionalDescription: 'Optional description of product features, types, color, sizes, etc.',
    customReviews: 'Custom reviews',
    addCustomReviews: 'Add reviews to your products',
    name: 'Name',
    nameTooltip: 'Enter name of your customer',
    comment: 'Comment',
    commentTooltip: 'Enter comment of your customer',
    rateTooltipCustomer: 'Rate of customer',
    imageTooltipCustomer: 'Upload image of your customer',
    displayPriceOnPreview: 'Display price on preview',
    displayDetailsOnPreview: 'Display details on preview',
    postOnSocials: 'Post on Socials',
    sendAnEmail: 'Send an Email',
    highlights: 'Highlights',
    listProductSetup: 'List product and set up your store block',
    whereToSell: 'Where would you like to sell this product?',
    youHaveProducts: 'You have {count} products',
    shareThisProduct: 'Share this product',
    shareAProduct: 'Share a product',
    monetizeWays: 'Different ways you can monetize on Unilink',
    addProductToProfile: 'Add a {title} to your profile',
    productPage: 'Product page',
    setUpPayments: 'Set up your payments',
    connectPaymentMethods: 'Connect your payment methods to start earning money on Unilink',
    addPaymentMethod: 'Add a {type} payment method to receive followers payments',
    withdrawAttempt: 'This is an attempt to collect a debt and any information will be used for that purpose.',
    withdrawSuccess: 'Your withdraw was successfully submitted!',
    yourVisitorsPay: 'Your visitors will pay first, and then will be directed to your {method}',
    emailAddress: 'email address',
    calendlyLink: 'Calendly link',
  },
  posts: {
    posts: 'Posts',
    title: 'Create your first post',
    description: 'Posts are where you create chat automations in an easy and visual format. Try some automations we recommend based on your goals',
    activate: 'Activate Posts',
    managePosts: 'Manage Posts',
    postsTab: 'Posts Tab',
    displayLast: 'Display last posts',
    tabNavigation: 'Tab navigation settings',
    createFirstPost: 'Create your first social post!',
    autoPostsText: 'Plan and publish content to all social media at once!',
    createPost: 'Create post',
  },
  messages: {
    title: 'Messages',
    empty: 'No Messages',
    addText: 'Add a message button to the Header block, allowing users to easily send you a message.',
    addButton: 'Add Message button',
  },
  smartReply: {
    title: 'Smart Reply',
    clicks: 'clicks',
    createTitle: 'Create your first Smart Reply!',
    text: 'Use Instagram Auto-DMs to automatically share links with your audience!',
    createButton: 'Create Smart Reply',
  },
  shortLinks: {
    title: 'Short Links',
    addLink: 'Add link',
    name: 'Name',
    slug: 'Slug',
    slugTooltip: 'You can change the Slug by clicking on the edit button',
    destinationUrl: 'Destination URL',
    metadata: 'Metadata',
    utmTags: 'UTM Tags',
    customizeMetadata: "Customize the link's metadata",
    metaTitle: 'Title',
    metaDescription: 'Description',
    favicon: 'Favicon',
    imagePreview: 'Image preview',
    addUtm: 'Add UTM tags to the link (optional)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Paste your long link here',
    shorten: 'Shorten link',
    edit: 'Edit item details',
  },
  audience: {
    title: 'Audience',
    total: 'Total',
    totalMembers: 'Total Audience Members',
    totalContacts: 'Total Contacts',
    forms: 'Forms',
    subscribers: 'Subscribers',
    customers: 'Customers',
    noAudienceMembers: 'No Contacts',
    emptyAudienceMembers: 'Add new contacts by clicking button',
    addAudienceMember: 'Add Contact',
    noSubscribers: 'No Subscribers',
    emptySubscribers: 'Add new subscribers by adding blocks to your Link in Bio',
    addDataCollect: 'Add Data Collect block',
    noResponses: 'No Responses',
    emptyResponses: 'Add new responses by adding blocks to your Link in Bio',
    addFormBlock: 'Add Form block',
    noCustomers: 'No Customers',
    emptyCustomers: 'Add new customers by adding product to your Link in Bio',
    addProduct: 'Add Product',
    addContactModal: {
      title: 'Add new contact',
      name: 'Name',
      nameTooltip: 'Enter the name for your contact',
      email: 'Email',
      emailTooltip: 'Enter the email address for your contact',
      phone: 'Phone',
      phoneTooltip: 'Enter the phone number for your contact',
      telegram: 'Telegram',
      telegramTooltip: 'Enter the Telegram username or URL for your contact',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Enter the WhatsApp number for your contact',
      instagram: 'Instagram',
      instagramTooltip: 'Enter the Instagram username or URL for your contact',
      messenger: 'Messenger',
      messengerTooltip: 'Enter the Messenger username or URL for your contact',
      viber: 'Viber',
      viberTooltip: 'Enter the Viber number for your contact',
      address: 'Address',
      addressTooltip: 'Enter the address for your contact',
      add: 'Add',
    },
    search: {
      search: 'Search',
      error: 'Invalid character entered in the search field',
      notFound: 'No results found',
    },
  },
  auth: {
    logIn: 'Log in',
    logInWith: 'Log in with',
    signIn: 'Sign in',
    signInWith: 'Sign up with',
    email: 'Email',
    password: 'Password',
    notHaveAccount: "Don't have an account?",
    createAccount: 'Create a new Account',
    createYourAccount: 'Create your Account',
    signUp: 'Sign up',
    haveAccount: 'If you already have an account',
    or: 'or',
    reset: 'Reset',
    resetPassword: 'Reset password',
    resetTitle: 'The recovery link has been sent to your email',
    goToHome: 'Go to Home page',
    byClicking: 'By clicking',
    youAreAgree: "you agree to UniLink's",
    terms: 'Terms of Service',
    andConfirm: 'and our',
    usagePolicy: 'Usage Policy',
    signInGoogle: 'Sign in with Google',
    forgotPassword: 'Forgot a password?',
  },
  menu: {
    moreApps: 'More apps',
    account: 'Account',
    more: 'More',
    storyWidget: 'Embed Stories',
    integrations: 'Integrations',
    socialAccounts: 'Social accounts',
    aiContent: 'AI Content',
    aiPosts: 'AI Posts',
    postIdeas: 'Post Ideas',
    contentPlanner: 'Content Planner',
    aiImages: 'AI Images',
    aiVideo: 'AI Video',
    planner: 'Planner',
    customers: 'Customers',
    subscribers: 'Subscribers',
    forms: 'Forms',
    allAudience: 'All audience',
    payments: 'Payments',
    orders: 'Orders',
    products: 'Products',
    events: 'Events',
    appointments: 'Appointments',
    discounts: 'Discounts',
    affiliates: 'Affiliates',
    instantPages: 'Instant Pages',
    openInNewTab: 'Open in new tab',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Website',
    store: 'Store',
    audience: 'Audience',
    emailMarketing: 'Email Marketing',
    postPlaner: 'Post Planner',
    posts: 'Posts',
    agents: 'Agents',
    community: 'Community',
    profileHealth: 'Profile Health',
    socialPlanner: 'Social Planner',
    shortLinks: 'Short Links',
    views: 'Views',
    clicks: 'Clicks',
    allWebsites: 'All Websites',
    createNewAccount: 'Create new account',
    createNewWebsite: 'Create a new profile',
    tools: 'Tools',
    borderGenerator: 'Border Generator',
    yourPlan: 'Your plan:',
    upgrade: 'Upgrade',
    accountSettings: 'Account settings',
    manageWebsites: 'Manage profiles',
    updates: 'Updates',
    autoUpdate: 'Auto update',
    logOut: 'Log out',
    myPages: 'My Pages',
    design: 'Design',
    heading: 'Heading',
    analytics: 'Analytics',
    settings: 'Settings',
    open: 'Open',
    language: 'Language',
    siteLanguage: 'Public site language',
    dashboardLanguage: 'Dashboard language',
    movePage: 'Move Page',
    editBlock: 'Edit Block',
    renameBlock: 'Rename Block',
    rename: 'Rename',
    deleteBlock: 'Delete Block',
    archiveBlock: 'Archive Block',
    archive: 'Archive',
    scheduleBlock: 'Schedule Block',
    copyBlock: 'Copy Block',
    dublicateBlock: 'Duplicate Block',
    content: 'Content',
    preview: 'Preview',
    copy: 'Copy',
    moveBlock: 'Move Block',
    move: 'Move',
    edit: 'Edit',
    delete: 'Delete',
    schedule: 'Schedule',
    dublicate: 'Duplicate',
    smartReply: 'Smart Reply',
    marketing: 'Marketing',
    selectBlocks: 'Select blocks',
    selectAll: 'Select all',
    cancelSelection: 'Cancel',
    blocksSelected: 'selected',
    moveToPage: 'Move to page',
    newPage: 'New Page',
    openPage: 'Open Page',
    pageSettings: 'Page Settings',
    deletePage: 'Delete Page',
    appInBio: 'App in Bio',
    blog: 'Blog',
    publish: 'Publish',
    creatorHub: 'Creator Hub',
    qrCodes: 'QR Codes',
    apps: 'Apps',
    automations: 'Automations',
    messages: 'Inbox',
    form: 'Embed Forms',
    embedTools: 'Embed Tools',
  },
  modal: {
    addInstagram: 'Add Instagram',
    addYourInstagram: 'Add your Instagram account',
    cropYourAvatar: 'Crop your avatar',
    removeSite: 'Are you sure you want to remove site?',
    areYouSure: 'Are you sure you want to',
    areYouSureDelete: 'Are you sure you want to delete this section?',
    areYouSureArchive: 'Are you sure you want to archive this block?',
    areYouSurePermanentDelete: 'Are you sure you want to permanently delete this block? This action cannot be undone.',
    remove: 'remove',
    site: 'site',
    removeAccountText: 'remove your account',
    moveBlock: 'Move block to another page',
    moveBlockText: 'This will move the block to the bottom of another page. You can then rearrange the block an the new page',
    profileTitle: 'Change profile picture',
    profileText: 'Choose an image, GIF from your device.',
    profileAvatar: 'Profile Avatar',
    addProfilePicture: 'Add Profile Picture',
    storiesTitle: 'Stories',
    storiesText: 'Share your everyday moments.',
    thoughtsTitle: 'Thoughts',
    thoughtsText: 'Share your thoughts.',
    accountPageDescription: 'This is your account page, where you can customize how your page looks, add different feature blocks, and more.',
  },
  modalSubscribe: {
    plan: 'Plan',
    usdMonth: 'USD/month',
    sites: 'Sites',
    sitesMuch: 'Sites',
    notification: 'Notifications',
    noNotification: 'No notifications yet',
    inCategory: 'There are no items in the',
    categoryYet: 'category yet.',
    externalPixels: 'External Pixels',
    parameters: 'parameters',
    analyticsReports: 'Analytics & Reports',
    noUniLinkLogo: 'No UniLink Logo',
    inProfile: 'in profile',
    verifiedBadge: 'Verified badge',
    your: 'Your',
    customDomain: 'custom Domain',
    emailMarketing: 'Email Marketing',
    liveSupport: 'Live Support',
    dataSecured: 'The data is secured in compliance with the PCI DSS standard',
    thankYou: 'Thank you for your interested. We will contact you soon.',
    socialMediaScheduler: 'Social Media Scheduler',
    featureRequest: 'Feature request',
    markAllRead: 'Mark all read',
    currentPlan: 'Current Plan',
    features: 'Features',
  },
  buttons: {
    upgrade: 'Upgrade Plan',
    buyProPlan: 'Buy Pro Plan',
    continue: 'Continue',
    skip: 'Skip',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    save: 'Save',
    add: 'Add',
    added: 'Added',
    done: 'Done',
    ok: 'OK',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    setAsDefault: 'Set as default',
    subscribeNow: 'Subscribe Now',
    yes: 'Yes',
    preview: 'Preview',
    generate: 'Generate',
    changePassword: 'Change password',
    deleteAccount: 'Delete account',
    removeAccount: 'Remove account',
    deleteProfile: 'Delete profile',
    addBlock: 'Add block',
    copyLink: 'Copy link',
    active: 'Active',
    update: 'Update',
    updatePro: 'Upgrade Plan',
    prev: 'Prev',
    next: 'Next',
    uploadImage: 'Upload image',
    uploadVideo: 'Upload video',
    loadMore: 'Load more',
    uploadProductImage: 'Upload product image',
    claim: 'Claim',
    removeSite: 'Remove site',
    move: 'Move',
    addButton: 'Add button',
    actionButton: 'Action button',
    directMessage: 'Direct message',
    subscribe: 'Subscribe',
    button: 'Button',
    generateWithAI: 'Generate with AI',
    cta: 'CTA',
    cart: 'Cart',
    direct: 'Direct',
    follow: 'Follow',
    addNewItem: 'Add new item',
  },
  support: {
    liveSupport: 'Live Support',
    response: 'We usually response in 1 minute during the working hours (8AM - 10PM) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Founder and CEO at UniLink',
  },
  wizard: {
    createNewProfile: 'Create a new profile',
    createProfile: 'Create Profile',
    continue: 'Continue',
    tellUs: 'Tell us about yourself',
    addSocialLinks: 'Add all social networks, and we will show them in your database',
    addMoreLinks: 'Add More Links',
    addLink: 'Add Link',
    selectCategory: 'Select one category that best describes you:',
    chooseTemplate: 'Choose a template',
    skip: 'Skip',
    step: 'Step',
    of: 'of',
    yourName: 'Your Name',
    search: 'Search',
    blog: 'Blog',
    creator: 'Creator',
    music: 'Music',
    events: 'Events',
    esoteric: 'Esoteric',
    fashion: 'Fashion',
    influencer: 'Influencer',
    food: 'Food',
    smallBusiness: 'Small Business',
    marketing: 'Marketing',
    education: 'Education',
    socialMedia: 'Social Media',
    coaching: 'Coaching',
    ecommerce: 'Ecommerce',
    healthAndFitness: 'Health and Fitness',
    beautyWellness: 'Beauty & Wellness',
  },
  billing: {
    back: 'Back',
    findPlan: 'Find the plan for you',
    changeAnytime: 'You can change at anytime.',
  },
  field: {
    fullName: 'Full Name',
    username: 'username',
    addValue: 'Add value',
    newValue: 'New value',
    placeholderDefault: 'Text, numbers, symbols etc.',
    addInstagramUsername: 'Add Instagram username',
    nameDefault: 'Jhon',
    enterYourLink: 'Enter your link',
    searchImage: 'Search image',
    pasteLink: 'Paste link',
    pasteLinkTip: 'Add a link to any web page',
    searchGIFs: 'Search GIFs',
    searchIcons: 'Search icons',
    searchVideo: 'Search video',
    search: 'Search',
    insertURL: 'Insert URL',
    writeYourDescription: 'Write your description',
    headerCTAbutton: 'Header, CTA button',
    enterTitle: 'Enter title',
    enterDescription: 'Enter description',
    enterURL: 'Enter canonical URL',
  },
  tooltip: {
    addImage: 'Add image',
    labelModalTitle: 'Label settings',
    addLabel: '+ Add label',
    label: 'Label',
    labelCaption: 'Enter label',
    labelText: 'Label text',
    labelTextCaption: 'Enter label text',
    labelTextPlaceholder: 'Label',
    labelUrl: 'Label URL',
    labelUrlCaption: 'Enter label URL',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'No label',
    colorFrom: 'Color from',
    colorTo: 'Color to',
    highlight: 'Highlight',
    firstName: 'First name',
    firstNameCaption: 'Enter your first name',
    lastName: 'Last name',
    lastNameCaption: 'Enter your last name',
    jobTitle: 'Job title',
    jobTitleCaption: 'Enter your job title',
    organization: 'Organization',
    organizationCaption: 'Enter your organization',
    email: 'Email',
    emailCaption: 'Enter your email',
    workPhone: 'Work phone',
    workPhoneCaption: 'Enter your work phone',
    mobilePhone: 'Mobile phone',
    mobilePhoneCaption: 'Enter your mobile phone',
    website: 'Website',
    websiteCaption: 'Enter your website',
    information: 'Information',
    informationCaption: 'Enter your information',
    streetAddress: 'Street address',
    streetAddressCaption: 'Enter your street address',
    city: 'City',
    cityCaption: 'Enter your city',
    state: 'State',
    stateCaption: 'Enter your state',
    postalCode: 'Postal code',
    postalCodeCaption: 'Enter your postal code',
    country: 'Country',
    countryCaption: 'Enter your country',
    titleColor: 'Title color',
    titleColorCaption: 'You can change title color',
    fontFamily: 'Font family',
    fontFamilyCaption: 'You can change font family',
    fontSize: 'Font size',
    fontSizeLabel: 'Label font size',
    fontSizeCaption: 'You can change font size',
    fontSelect: 'Font',
    fontSelectCaption: 'Choose a font',
    imageMargin: 'Image margin',
    profilePicture: 'Profile picture',
    profilePictureCaption: 'Change your profile picture',
    pictureSize: 'Picture size',
    pictureSizeCaption: 'You can change picture size',
    title: 'Title',
    titleCaption: 'Enter a title',
    blockCaption: 'Enter a title of your block',
    titlePageCaption: 'Enter a title of your page',
    templates: 'Templates',
    templatesCaption: 'Choose a template for your page',
    myTemplates: 'My templates',
    myTemplatesEmpty: 'No templates yet. Save your current page design to reuse it later.',
    saveAsTemplate: 'Save as Template',
    saveCurrentAsTemplate: 'Save current as template',
    templateSaved: 'Template saved',
    templateApplied: 'Template applied',
    templateKind: 'What to include',
    publish: 'Publish',
    unpublish: 'Unpublish',
    templatePublished: 'Template published',
    templateUnpublished: 'Template unpublished',
    discoverTemplates: 'Discover community',
    discoverSubtitle: 'Free templates published by other creators on UniLink.',
    discoverEmpty: 'No public templates yet — be the first to publish one.',
    pricing: 'Pricing',
    background: 'Background',
    backgroundColor: 'Background color',
    textBackground: 'Text Background',
    textBackgroundCaption: 'Choose text background color',
    textColor: 'Text Color',
    textColorCaption: 'Choose text color',
    gradientBackground: 'Gradient Background',
    gradientColor: 'Gradient Color',
    BackgroundType: 'Type',
    backgroundSource: 'Background source',
    backgroundSourceCaption: 'Choose background source',
    backgroundStyle: 'Background style',
    backgroundStyleCaption: 'Choose background style',
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Glass',
    backgroundStylesOutline: 'Outline',
    backgroundTypeCaption: 'Choose type background',
    color: 'Color',
    colorTooltip: 'You can change color',
    backgroundOpacityTooltip: 'Drag slider to set background opacity',
    backgroundBlur: 'Background blur',
    backgroundBlurCaption: 'Drag slider to blur a background blur',
    backgroundBrightness: 'Background brightness',
    backgroundBrightnessCaption: 'Drag the slider to change the background brightness',
    backgroundContrast: 'Background contrast',
    backgroundContrastCaption: 'Drag the slider to change the background contrast',
    color1: 'Color 1',
    color2: 'Color 2',
    colorCaption: 'Enter color of your page',
    gradient: 'Gradient',
    image: 'Image',
    photo: 'Photo',
    gif: 'GIF',
    animation: 'Animation',
    video: 'Video',
    hexColor: 'Hex color',
    direction: 'Direction',
    gradientDirection: 'Gradient direction',
    directionCaption: 'Drag slider to set direction of a gradient',
    offset: 'Offset',
    gradientOffset: 'Gradient offset',
    offsetCaption: 'Drag slider to set offset of a gradient',
    backgroundDarkness: 'Background darkness',
    backgroundDarknessCaption: 'Drag slider to darken a background image',
    uploadVideo: 'Upload video',
    uploadFile: 'Upload file',
    uploadVideoCaption: 'Video of your page background',
    linkToVideo: 'Link to video',
    linkToVideoCaption: 'Add link to video',
    videoWithSound: 'Video with sound',
    videoWithSoundCaption: 'Play video with sound',
    fonts: 'Fonts',
    fontWeight: 'Font weight',
    fontWeightCaption: 'Click to choose your destiny',
    preloader: 'Preloader',
    preview: 'Preview',
    hideLogo: 'Hide UniLink logo',
    cover: 'Cover',
    coverCaption: 'Change cover',
    coverCaptionHeader: 'Add image or video to header cover',
    pageNavigation: 'Page navigation',
    websiteNavigation: 'Tab navigation',
    backgroundOpacity: 'Background opacity',
    backgroundOpacityCaption: 'Drag slider to opacity button background',
    borderRadius: 'Border radius',
    borderRadiusCaption: 'Drag slider to set border radius',
    heightTabs: 'Height tabs',
    heightTabsCaption: 'Drag slider to set height of tabs',
    backgroundShadow: 'Background shadow',
    backgroundShape: 'Background shape',
    backgroundBorder: 'Background border',
    opacity: 'Opacity',
    opacityCaption: 'Drag slider to set opacity',
    shape: 'Shape',
    shapeCaption: 'Set shape',
    text: 'Text',
    textCaption: 'Enter text',
    textSize: 'Text size',
    textSizeCaption: 'Drag slider to set text size',
    additionalText: 'Additional text',
    username: 'Username',
    currency: 'Currency',
    language: 'Language',
    timeZone: 'Time zone',
    websiteNiche: 'Website niche',
    websiteNicheCaption: 'Enter your website niche',
    renameCaption: 'Rename block title',
    description: 'Description',
    descriptionCaption: 'Enter a description',
    actionButton: 'Action button',
    actionButtonCaption: 'Call To Action button motivates visitors to take action',
    animationDirection: 'Animation direction',
    animationDirectionCaption: 'Choose animation direction',
    buttonTitle: 'Button title',
    buttonTitleCaption: 'Enter button title',
    buttonUrl: 'Button URL',
    buttonUrlCaption: 'URL will open in a new window',
    imageSize: 'Image size',
    imageSizeCaption: 'Drag slider to set image size',
    view: 'View',
    viewCaption: 'Choose a view',
    margin: 'Margin',
    marginCaption: 'Drag slider to add margin to both top and bottom of the item',
    separateTopBottom: 'Top / Bottom',
    padding: 'Padding',
    paddingCaption: 'Drag slider to add padding to top and bottom of the item',
    fullWidth: 'Full width',
    lineHeight: 'Line height',
    lineHeightCaption: 'You can change line height',
    button: 'Button',
    titleSize: 'Title size',
    titleSizeCaption: 'You can change title size',
    titleLineHeight: 'Title line height',
    titleLineHeightCaption: 'Customize your title line height to bring more design solutions to the text',
    layout: 'Layout',
    layoutCaption: 'Create the header layout you want',
    layoutAlign: 'Layout align',
    alignText: 'Align text',
    align: 'Align',
    alignCaption: 'Choose alignment',
    position: 'Position',
    positionCaption: 'Choose position',
    width: 'Width',
    widthCaption: 'Choose width of your banner',
    nameHeader: 'Name (leave blank to reset)',
    nameCaption: 'Enter name of your account',
    shortBio: 'Short bio',
    shortBioCaption: 'Enter short bio of your account',
    externalLink: 'External link',
    externalLinkCaption: 'Enter external link to your account',
    location: 'Location',
    locationCaption: 'Enter your location',
    locationMap: 'Location map',
    locationMapCaption: 'Enter URL of your location',
    rightIcon: 'Right icon',
    rightIconCaption: 'This icon will appear on right side of button',
    buttons: 'Buttons',
    buttonsCaption: 'Add action buttons',
    nameLogo: 'Name logo',
    nameLogoCaption: 'Upload logo for your name',
    buttonText: 'Button text',
    buttonTextCaption: 'Enter name of your button',
    buttonColor: 'Button color',
    buttonColorCaption: 'Choose colors for button',
    buttonColorCTACaption: 'Choose background color for CTA button',
    cartColor: 'Cart color',
    cartColorCaption: 'Choose background color for cart',
    ctaButton: 'CTA button',
    ctaButtonCaption: 'This icon will appear on right side of button',
    style: 'Style',
    socialIconsStyleCaption: 'You can choose style of your social icons',
    socialIconsShape: 'Social icons shape',
    socialIconsShapeCaption: 'You can choose social icons shape',
    headerTextColorCaption: 'You can choose header text color',
    pictureShape: 'Picture shape',
    pictureShapeCaption: 'You can choose profile picture shape',
    socialLinks: 'Social links',
    socialLinksCaption: 'Add social links buttons for fast connection between you and your clients in one click',
    URL: 'URL',
    URLCaption: 'Enter URL address',
    heading: 'Heading',
    headingTitle: 'Heading title',
    headingTitleCaption: 'Enter heading title',
    headingDescription: 'Heading description',
    headingDescriptionCaption: 'Enter heading description',
    headingImage: 'Heading image',
    headingImageCaption: 'Upload image for your heading',
    headingPosition: 'Heading position',
    headingInsideBlock: 'Inside block',
    headingOutsideBlock: 'Outside block',
    headingDivider: 'Heading divider',
    canonicalURL: 'Canonical URL',
    seo: 'SEO',
    seoCaption: 'Customize your product with meta SEO tags',
    themes: 'Themes',
    brandColors: 'Brand Colors',
    applyBrandColors: 'Apply to Profile',
    syncBlocks: 'Sync All Blocks',
    brandColorsApplied: 'Brand colors applied',
    generatedPalette: 'Generated Palette',
    applying: 'Applying...',
    syncing: 'Syncing...',
    backgroundType: 'Background type',
    palettes: 'Palettes',
    previewTitle: 'Title',
    previewTitleCaption: 'Enter preview title',
    previewDescription: 'Description',
    previewDescriptionCaption: 'Enter preview description',
    previewButton: 'Button text',
    previewButtonCaption: 'Enter preview button text',
    previewLabel: 'Label text',
    previewLabelCaption: 'Enter preview label text',
    previewThumbnail: 'Thumbnail',
    previewThumbnailCaption: 'Upload preview thumbnail',
  },
  table: {
    clicks: 'Clicks',
    signups: 'Sign-Ups',
    views: 'Impressions',
    orderNumber: 'Order number',
    amount: 'Amount',
    credits: 'Credits',
    invoice: 'Invoice',
    email: 'Email',
    card: 'Card',
    currency: 'Currency',
    name: 'Name',
    contact: 'Contact',
    optIn: 'Opt-in',
    notes: 'Notes',
    address: 'Address',
    date: 'Date',
    action: 'Action',
    custom: 'Custom',
    status: 'Status',
    tags: 'Tags',
    view: 'View',
    remove: 'Remove',
    sendEmail: 'Send Email',
    details: 'Details',
    purchases: 'Purchases',
    order: 'Order',
    money: 'Money',
    type: 'Type',
    orderCode: 'Order code',
  },
  settings: {
    title: 'Settings',
    settings: 'settings',
    accountSettings: 'Account settings',
    email: 'Email',
    subscription: 'Subscription',
    billingHistory: 'Billing history',
    dueTo: 'Due to',
    subscriptionDueTo: 'Subscription due to',
    cancelSubscription: 'Cancel subscription',
    cancelSubscriptionConfirm: 'Are you sure you want to cancel your subscription?',
    subscriptionCancelled: 'Your subscription has been cancelled. Your plan remains active until the end of the billing period.',
    subscriptionCancelError: 'Failed to cancel subscription. Please contact support.',
    deleteFirst: 'Permanently delete your',
    deleteSecond: 'and all its data. This action cannot be undone.',
    account: {
      title: 'Account',
      usernameNotAvailable: 'Username is not available',
      setupCustomDomain: 'Setup custom domain',
      subtitle: 'Account email, billing, password and api key',
    },
    profile: {
      title: 'Profile',
      usernameNotAvailable: 'Username is not available',
      setupCustomDomain: 'Setup custom domain',
      subtitle: 'Manage username, language, currency, timezone',
      category: 'Category',
      categoryCaption: 'Enter category of your profile',
    },
    aiassistant: {
      title: 'AI Assistant',
      subtitle: 'Customize your AI assistant for better, more personalized responses',
      titleText: 'Help the AI understand who you are for more relevant responses',
      customAiTitle: 'Custom instructions',
      customAiPlaceholder: 'Add any specific instructions for the AI...',
      customAiDescription: 'These instructions will be applied to every conversation with the AI',
      nicknameTitle: 'What should AI call you?',
      nicknamePlaceholder: 'Nickname',
      titleBio: 'Bio/ Description',
      bioPlaceholder: 'Tell us a bit about yourself...',
      occupation: 'What do you do?',
      occupationPlaceholder: 'e.g. Engeneering student at University of Waterloo',

      aboutYouTitle: 'About You',
      aboutYouTooltip: 'Tell your AI assistant a little about yourself',
      locationTitle: 'Location',
      locationPlaceholder: 'e.g. Kyiv, Ukraine',
      categoryTitle: 'Category',
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Set up notifications about new visitors emails and orders',
      text: "Connect messengers to get notifications about new client's email and order",
      setUpWebhooks: 'Set up webhooks in Webhooks section',
      save: 'Save',
      connect: 'CONNECT',
      disconnect: 'DISCONNECT',
      webhook: 'Webhook',
      emailSubmit: 'Data collect submit',
      formSubmit: 'Form submit',
      showSubmit: 'Shop submit',
      digitalSubmit: 'Digital submit',
      appointmentSubmit: 'Appointment submit',
      requestSubmit: 'Service submit',
      donationSubmit: 'Donation submit',
      email: 'Email',
      settings: 'settings',
      cartSubmit: 'Cart submit',
      linkClick: 'Link click',
      contactClick: 'Contact click',
      all: 'All',
      updates: 'Updates',
      messages: 'Messages',
      opportunities: 'Opportunities',
      insights: 'Insights',
      activity: 'Activity',
      system: 'System',
      news: 'News',
      more: 'Show more',
      less: 'Show less',
      connectedAccounts: 'Connected accounts',
      addEmailAccount: 'Add email account',
    },
    paymentSystem: {
      title: 'Payment system',
      subtitle: 'Set up payouts through Stripe or PayPal',
      text: 'View processing fees',
      connected: 'Connected',
      active: 'Accept payments on website',
      pending: 'Pending',
      disconnect: 'Disconnect',
      connect: 'Connect',
      add: 'Add',
      ofYourAccount: 'of your account',
      save: 'Save',
    },
    shop: {
      title: 'Shop',
      subtitle: 'Setting category and property',
      label: {
        title: 'Labels',
        subtitle: 'Add labels to product cards',
        addValue: 'Add value',
        save: 'Save',
        value: 'Value',
        enterTitle: 'Enter title',
        maximum: 'Maximum number of values can be 5',
        add: 'Add',
        edit: 'Edit',
        labels: 'Labels',
      },
      category: {
        title: 'Categories',
        subtitle: 'Add category to your products',
        addCategory: 'Add category',
        save: 'Save',
        maximum: 'Maximum number can be',
      },
      property: {
        title: 'Property',
        subtitle: 'Add property to your products',
        addProperties: 'Add properties',
        properties: 'Properties',
        type: 'Type',
        typeTooltip: 'Type of your properties',
        titleModal: 'Title',
        titleModalTooltip: 'Name of your properties',
        enterTitle: 'Enter the title',
        value: 'Value',
        addValue: 'Add value',
        maximum: 'Maximum number of values can be',
        save: 'Save',
        cancel: 'Cancel',
        remove: 'Remove',
        addPropertyToItem: 'Add property to item',
        add: 'Add',
        edit: 'Edit',
        propertiesSmall: 'properties',
        required: 'Required',
        requiredTooltip: 'Set required properties for buying',
        selectAll: 'Select all',
      },
      preorderForm: {
        title: 'Preorder form',
        subtitle: 'Setup preorder form fields',
        fields: 'Fields',
        fieldsTooltip: 'Add fields to the form',
        required: 'Required',
        submitButton: 'Submit button title',
        redirectUrl: 'Redirect url (optional)',
        resultText: 'Result text',
        save: 'Save',
        name: 'Name',
        emailAddress: 'Email address',
        phone: 'Phone',
        address: 'Address',
        comment: 'Comment',
      },
      shipping: {
        title: 'Shipping',
        subtitle: 'Setup shipping fields',
        fields: 'Fields',
        fieldsTooltip: 'Add fields to the shipping form',
        required: 'Required',
        save: 'Save',
        name: 'Name',
        emailAddress: 'Email address',
        phone: 'Phone',
        address: 'Address',
        comment: 'Comment',
        addCustomField: 'Add custom field',
        addFormInfo: 'Add form info',
        editFormInfo: 'Edit form info',
        type: 'Type',
        typeTooltip: 'Custom field type',
        fieldName: 'Field name',
        fieldNameTooltip: 'Name for custom field',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder for custom field',
        delete: 'Delete',
        update: 'Update',
        add: 'Add',
      },
      delivery: {
        title: 'Delivery methods',
        subtitle: 'Configure shipping, local delivery and self-pickup for your shop.',
        loading: 'Loading…',
        inactive: 'inactive',
        confirmDelete: 'Delete this delivery method?',
        category: { shipping: 'Shipping', localDelivery: 'Local delivery', selfPickup: 'Self pickup' },
        rateType: { free: 'Free', conditionalFree: 'Conditional free', flatRate: 'Flat rate', customRates: 'Custom rates', carrierApi: 'Carrier API' },
        carrier: { custom: 'Custom carrier' },
        add: { shipping: 'Add Shipping', localDelivery: 'Add Local delivery', selfPickup: 'Add Self pickup' },
        actions: { edit: 'Edit', delete: 'Delete', save: 'Save', cancel: 'Cancel' },
        fields: {
          name: 'Name',
          namePh: 'e.g. Standard shipping',
          description: 'Description',
          isActive: 'Active',
          estimatedDays: 'Estimated days',
          currency: 'Currency',
          countryCodes: 'Country codes (CSV)',
          carrier: 'Carrier',
          rateType: 'Rate type',
          flatPrice: 'Flat price',
          freeThreshold: 'Free over (subtotal)',
          fallbackPrice: 'Fallback price',
          customRates: 'Custom rate rows',
          senderCity: 'Sender city name',
          senderCityRef: 'Sender city ref',
          pickupInstructions: 'Pickup instructions',
          pickupCharge: 'Pickup charge',
          askPickupDateTime: 'Ask pickup date/time at checkout',
        },
        rateRow: { subtotal: 'By subtotal', weight: 'By weight (g)', min: 'Min', max: 'Max', price: 'Price', add: 'Add row' },
      },
      legal: {
        title: 'Legal documents',
        subtitle: 'Terms, Privacy, Return policy — shown to customers at checkout.',
        loading: 'Loading…',
        empty: 'No legal documents yet.',
        inactive: 'inactive',
        required: 'required',
        confirmDelete: 'Delete this document?',
        addNew: '+ Add document',
        types: {
          terms: 'Terms of Service',
          privacy: 'Privacy Policy',
          returns: 'Return / Refund Policy',
          shipping: 'Shipping Policy',
          cookies: 'Cookie Policy',
          custom: 'Custom',
        },
        fields: {
          title: 'Title',
          titlePh: 'e.g. Terms of Service',
          type: 'Document type',
          content: 'Content',
          contentPh: 'Write your legal text here…',
          isActive: 'Active',
          requireAcceptance: 'Require acceptance at checkout',
        },
        actions: { edit: 'Edit', delete: 'Delete', save: 'Save', cancel: 'Cancel' },
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Customize your page with meta SEO tags',
      titleText: 'Title',
      titlePlaceholder: 'Enter page title',
      description: 'Description',
      descriptionPlaceholder: 'Enter page description',
      favicon: 'Favicon',
      uploadFavicon: 'Upload favicon',
      imagePreview: 'Image preview',
      useCustom: 'Use custom image',
      save: 'Save',
      visualise: 'Visualise how your website preview will look like in Google',
      inMessengers: 'In messengers',
      inSocial: 'In social media',
      searchEngine: 'Search engine',
      googleIndexable: 'Google indexable',
      sitemap: {
        title: 'Sitemap',
        entryHint: 'Manage which pages and products search engines can index.',
        setupLink: 'customize',
        mainEntry: 'Index Website',
        subtitle: 'Choose which pages search engines should index. Disabled pages get a noindex tag and are removed from your sitemap.',
        mainPage: 'Main profile page',
        pagesSection: 'Pages',
        pagesHint: 'Toggle indexing for each additional page of your site.',
        noPages: 'No additional pages yet.',
        productsSection: 'Products',
        productsHint: 'Toggle indexing for individual product pages.',
        noProducts: 'No products yet.',
        postsSection: 'Posts',
        postsHint: 'Toggle indexing for individual posts.',
        noPosts: 'No posts yet.',
        blogSection: 'Blog articles',
        blogHint: 'Toggle indexing for individual blog articles.',
        noArticles: 'No blog articles yet.',
        loadMore: 'Load more',
        loading: 'Loading…',
      },
    },
    analytics: {
      title: 'Analytics',
      subtitle: 'Integrate Facebook Pixel, Google Analytics, and an UTM parameters',
      facebookTooltip: 'Connect Facebook to display analytics',
      googleAnalyticsTooltip: 'Google Analytics lets you measure your advertising ROI as well as track all your links.',
      googleTagManagerTooltip: 'Google tag manager lets you configure and instantly deploy tags on your website',
      tikTokPixelTooltip: 'The TikTok Pixel is a powerful measurement tool that tracks your TikTok ads impact on your website',
      pinterestTag: 'Pinterest tag',
      pinterestTagTooltip:
        'The Pinterest tag is a piece of code that you add to your website which lets Pinterest track visitors to your site as well as the actions they take on your site after seeing your Pinterest ad.',
      tag: 'tag',
      headerTagTooltip: 'Paste tag that appears in the head of your website',
      bodyTagTooltip: 'Paste tag that appears in the body of your website',
      utmParameters: 'UTM parameters',
      utmParametersTooltip: 'Collect campaign data with custom URLs. Add parameters to URLs to identify the campaigns that refer traffic.',
      makeAnalytics: 'Make Google Analytics show UniLink traffic as Social',
      the: 'The',
      campaign: 'campaign',
      parameter: 'parameter is set dynamically from the title of each post or link',
      save: 'Save',
    },
    customDomain: {
      title: 'Custom domain',
      subtitle: 'Customize your page with custom domain',
      titleTooltip: 'Add custom domain',
      save: 'Save',
      connect: 'Connect',
      connecting: 'Connecting',
      instructions: 'Instructions',
      submit: 'Submit',
      submitting: 'Submitting...',
      enterDomain: 'Enter your domain',
      domainPlaceholder: 'your-domain.com',
      steps: {
        submitting: 'Submitting request',
        validation: 'Domain validation',
        certificate: 'Certificate provisioning',
        complete: 'Complete',
      },
      txtRecord: {
        title: 'TXT Record',
        description: 'Add the following TXT record to your DNS settings:',
        verifyButton: 'Verify TXT Record',
        verifying: 'Verifying...',
        verified: 'TXT record verified',
      },
      cnameRecord: {
        title: 'CNAME Record',
        description: 'Add the following CNAME record to your DNS settings:',
        verifyButton: 'Verify CNAME Record',
        verifying: 'Verifying...',
        verified: 'CNAME record verified',
      },
      dnsTable: {
        type: 'Type',
        host: 'Host',
        value: 'Value',
        ttl: 'TTL',
        copy: 'Copy',
        copied: 'Copied!',
      },
      provisioning: {
        title: 'SSL certificate is being provisioned...',
        description: 'This may take a few minutes. Please wait.',
        timeout: 'Certificate provisioning is taking longer than expected. Please check back later.',
      },
      complete: {
        title: 'HTTPS has been successfully enabled on your domain.',
        connected: 'Connected',
      },
      failed: {
        title: 'Domain connection failed',
        tryAgain: 'Try Again',
      },
      rootDomainWarning: 'Root domains require your DNS provider to support CNAME flattening (e.g., Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Disconnect domain',
        message: 'Are you sure you want to disconnect this domain? Your website will no longer be accessible via this domain.',
        confirm: 'Disconnect',
        cancel: 'Cancel',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: 'Send real-time event notifications to external services',
      webhook: 'Webhook',
      webhookTooltip: 'Add webhook',
      send: 'Send events to 3d party website',
      webhookUrl: 'Webhook URL (POST request)',
      error: 'Enter correct link',
      save: 'Save changes',
      enableWebhooks: 'Enable Webhooks',
      enableDescription: 'POST requests on selected events',
      endpointUrl: 'Endpoint URL',
      endpointTooltip: 'The URL that will receive POST requests when selected events occur',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Events',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      filterPlaceholder: 'Filter events...',
      all: 'All',
      none: 'None',
      active: 'Active',
      inactive: 'Inactive',
      categories: {
        submissions: 'Submissions',
        engagement: 'Engagement',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Header Subscribe',
        SubmitHeaderMessage: 'Header Message',
        SubmitDataCollect: 'Data Collect',
        SubmitForm: 'Form Submit',
        SubmitShop: 'Shop Order',
        SubmitShopPreorder: 'Shop Preorder',
        SubmitDigital: 'Digital Product',
        SubmitAppointment: 'Appointment',
        SubmitService: 'Service Order',
        SubmitEvent: 'Event Registration',
        SubmitCourse: 'Course Enrollment',
        SubmitDonation: 'Donation',
        SubmitMembership: 'Membership',
        SubmitBlog: 'Blog Purchase',
        SubmitCoupon: 'Coupon Used',
        SubmitTip: 'Tip',
        SubmitLink: 'Link Purchase',
        SubmitProductMessage: 'Product Question',
        SubmitPodcast: 'Podcast Purchase',
        SubmitBooking: 'Booking',
        SubmitRental: 'Rental',
        SubmitSingleProduct: 'Single Product',
        SubmitDiscount: 'Discount Order',
        SubmitListing: 'Listing Request',
        SubmitUnlock: 'Content Unlock',
        SubmitChatAi: 'AI Chat Message',
        ClickLink: 'Link Click',
        ClickContact: 'Contact Click',
        AddToCart: 'Add to Cart',
        AddToCartSingleProduct: 'Single Product to Cart',
        AddToWishlist: 'Add to Wishlist',
        InitiateCheckout: 'Initiate Checkout',
        DownloadFile: 'File Download',
        DownloadMusic: 'Music Download',
        CopyCoupon: 'Copy Coupon',
        CopyDiscount: 'Copy Discount',
        QR_ScanQrCode: 'QR Code Scan',
        VisitPage: 'Page Visit',
      },
    },
    sensitive: {
      title: 'Sensitive material',
      subtitle: 'Show a sensitive content warning before displaying your website',
    },
    socialIntegration: {
      title: 'Social integrations',
      subtitle: 'Manage your Instagram, TikTok integrations',
      connectInstagram: 'Connect instagram',
    },
    emailIntegration: {
      title: 'Audience integrations', //Mailing integration
      subtitle: 'Pass your visitors email addresses to MailChimp, Reply',
      emailCaption: 'Add an integration to pass your followers email addresses to MailChimp',
      mailChimp: 'MailChimp integrations',
      selzy: 'Selzy integrations',
      selzyCaption: 'Add an API key to pass your followers email addresses to Selzy',
      sendPulse: 'SendPulse integrations',
      sendPulseCaption: 'Add an API key to pass your followers email addresses to SendPulse',
      reply: 'Reply integrations',
      replyCaption: 'Add an API key to pass your followers email addresses to',
      integrations: 'integrations',
    },
    calendarIntegration: {
      title: 'Calendar integrations',
      subtitle: 'Connect your calendar services',
      calendly: 'Calendly',
      calendlyDescription: 'Connect Calendly to sync your event types and availability',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Connect Google Calendar to sync events and create Google Meet links',
      zoom: 'Zoom',
      zoomDescription: 'Connect Zoom to create meeting links automatically',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Create Google Meet links automatically (requires Google Calendar)',
    },
    storage: {
      title: 'Storage',
      subtitle: 'Save visitors order to Google Spreadsheet',
      storageCaption: "Add an integration to save all client's order to Google Spreadsheet",
      emailSignup: 'Email signup',
      emailSignupsCaption: 'Choose table for saving email signup',
      formSignups: 'Form Signup',
      forSignupsCaption: 'Choose table for saving form signup',
      shopOrders: 'Shop orders',
      shopOrderCaption: 'Choose table for saving shop orders',
      disconnect: 'Disconnect spreadsheet',
      storageUsage: 'Storage usage',
      of: 'of',
      uses: 'This app uses',
      space: 'of your free disk space',
      view: 'view details',
      noItems: 'There is no items',
      files: 'Files',
      images: 'Images',
      videos: 'Videos',
      audio: 'Audio',
      settings: 'settings',
      free: 'free',
      needMoreSpace: 'Need more space?',
      unlockStorage: 'Unlock unlimited storage, 4K video',
      upgradePlan: 'Upgrade Plan',
      addFile: 'Add file',
      uploading: 'Uploading...',
      dragDrop: 'or drag and drop here',
      noFilesYet: 'No files yet',
      noImagesYet: 'No images yet',
      noVideosYet: 'No videos yet',
      noAudioYet: 'No audio yet',
      filesHint: 'Upload PDFs, docs and other downloads to attach them to your bio page links.',
      imagesHint: 'Upload images to use across your bio page.',
      videosHint: 'Upload videos to embed on your bio page.',
      audioHint: 'Upload audio tracks to share on your bio page.',
    },
  },
  productStore: {
    title: 'Show Store tab on your link-in-bio',
    subtitle: 'Your Store is currently hidden.',
  },
  sections: {
    splashScreen: {
      title: 'Splash Screen',
      subtitle: 'Shows up while the page is loading',
    },
    promo: {
      title: 'Promo bar',
      subtitle: 'Highlight that lets you appear promotions',
      masterPromoMessage: 'The Master Promobar is currently enabled. If you wish to create a custom promobar for this page, you will need to disable the Master Promobar first.',
      titlePlaceholder: 'Welcome to my website!',
      switcherIsMasterPromobar: 'Show on all pages',
    },
    contact: {
      title: 'Contacts',
      subtitle: 'Provide the way to communicate with you',
      caption: 'Add messenger buttons for fast connection between you and your clients in one click',
      tooltip: 'Contacts allows users to communicate with you directly. Add your phone, email, messenger, or location',
      addNewContact: 'Add new contact',
      addContact: 'Add contact',
      chooseContact: 'Choose contact',
      enterLink: 'Enter your contact link',
      showDetails: 'Show details',
      enterAnyContact: 'Please enter any contact',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Membership',
      subtitle: 'Create a free or paid subscription to your content',
      addNewTier: 'Add new tier',
      editTier: 'Edit tier',
      name: 'Name',
      nameCaption: 'Enter name of your tier',
      price: 'Price per month',
      priceCaption: 'Enter price of your tier',
      month: 'month',
      image: 'Image',
      imageCaption: 'Upload image for your tier',
    },
    pricing: {
      title: 'Pricing',
      subtitle: 'Create a menu with prices',
      add: 'Add new item',
      edit: 'Edit item',
      name: 'Name',
      nameCaption: 'Enter name of your item',
      duration: 'Attribute',
      durationCaption: 'Enter time, quantity or duration of your item',
      category: 'Category',
      categoryCaption: 'Enter category of your item',
      price: 'Price',
      priceCaption: 'Enter price of your item',
      month: 'month',
      image: 'Image',
      imageCaption: 'Upload image for your item',
    },
    subscribe: {
      dataCollectTitle: 'Data Collect',
      title: 'Subscribe',
      subtitle: 'Collect emails or phone numbers from your visitors',
      instructionsMessage: 'Add an Email signup field to your page so your visitors can easily signup!',
      instructionsLink: 'Pass emails to MailChimp to run marketing campaigns.',
      sectionHeaderCaption: 'Subscribe to our newsletter',
      collecting: 'Collecting',
      collectingCaption: 'Choose your type of input',
      addDataToCollect: 'Add data to collect',
      email: 'Email',
      enterEmail: 'Enter email',
      thanksForEmail: 'Thank you for your email',
      phone: 'Phone',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Add updated links',
      placeholder: 'Placeholder',
      placeholderCaption: 'Enter placeholder text',
      button: 'Button',
      buttonCaption: 'Text that will motivate visitor to enter email (10% off discount, subscribe now, download file etc.)',
      submitButton: 'Submit button',
      enterButton: 'Enter button',
      thanksMessage: 'Thanks message',
      thanksMessageCaption: 'Thanks message of your subscribes',
      resultAction: 'Action (after submitting)',
      resultActionCaption: 'Action after filling out the form',
      sendAnEmail: 'Send an email',
      downloadFile: 'Download file',
      redirect: 'Redirect',
      messageBody: 'Message body',
      messageBodyCaption: 'This data will be sent to user email as present for his email (coupon, link to file download, etc.)',
      integration: 'Integration',
      integrationCaption: 'Pass your visitors email addresses to MailChimp, Reply',
      storage: 'Storage',
      storageCaption: 'Save visitors order to Google Spreadsheet',
      maxSize: 'You can add maximum 3 channels',
    },
    text: {
      title: 'Text',
      subtitle: 'Write anything about yourself/company',
      trimBio: 'Show More button',
    },
    header: {
      title: 'Header',
      subtitle: 'Enlarged featured image or video on your page',
      verifiedBadge: 'Verified badge',
      showProfilePic: 'Display profile picture',
      profilePicRatio: 'Ratio',
      profilePicRatioSquare: 'Square',
      profilePicRatioLandscape: 'Landscape',
      profilePicRatioPortrait: 'Portrait',
      namePlaceholder: 'Your name',
      shortBioPlaceholder: 'My short information',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'City',
      addSocial: '+ Add social',
      addCover: '+ Add cover',
      addButton: '+ Add button',
      addText: '+ Add text',
      addLabel: '+ Add label',
      subtitleName: 'Customize your name appearance',
      subtitleShortBio: 'Customize your short bio appearance',
      shortBioSize: 'Short Bio size',
      subtitleShortBioSize: 'You can change short bio size',
      subtitleLocation: 'Set the city/country to navigate visitors to a specific place',
      headerCoverWarningMessage: 'Your browser does not support the video tag.',
      headerCoverTitle: 'Set cover above the header',
      coverHeight: 'Cover height',
      subtitleCoverHeight: 'You can change cover height',
      coverDarkness: 'Cover darkness',
      subtitleCoverDarkness: 'Drag slider to darken cover image',
      nameSize: 'Name size',
      subtitleNameSize: 'You can change name size',
      positionText: 'Position name',
      subtitlePositionName: 'Drag slider to set name position',
      positionContent: 'Position content',
      subtitlePositionContent: 'Set position for bio, link, location',
      coverText: 'Text on cover',
      subtitleCoverText: 'Add text to your cover',
      position: 'Position',
      subtitlePosition: 'Drag slider to set button position',
      buttonCover: 'Button on cover',
      subtitleButtonCover: 'Add a button to your cover by choosing an action',
      subtitleFollow: 'Follow button allows users to follow your news',
      buttonOpacity: 'Drag slider to change button opacity',
      subtitleCart: 'Cart icon to deliver a shopping experience',
      subtitleDirect: 'Quick button to navigate visitor to messengers',
      subtitleCTAButton: '(call to action) button that motivates user to click',
      subtitleSocialLinks: 'Give your social networks a visual look',

      chooseSocialLink: 'Choose social link',
      alignSocialLink: 'Social links align',
      enterYourSocialLink: 'Enter your social link',
      blockShadow: 'Block shadow',
      activeButtonPosition: 'Active button position',

      gradientColor: 'Gradient color',
      bottomGradient: 'Bottom gradient',
      autoGradient: 'Auto',
      customGradient: 'Custom',
      uploadLogo: 'Upload Logo',
      customBackground: 'Custom background',
      headingLabel: 'Heading Label',
      customizeLabel: 'Customize your heading label appearance',
      labelText: 'Label Text',
      enterLabelText: 'Enter text for the heading label',
    },
  },
  billingHistory: {
    title: 'Billing history',
    invoices: 'Invoices',
    messageText: 'You have no payment history yet.',
  },
  migrate: {
    title: 'Do you have LinkTree or Taplink?',
    text: 'Paste link and migrate to UniLink in just one click!',
    button: 'Migrate',
  },
  pages: {
    title: 'Pages',
    addPage: 'Add page',
    addNewPage: 'Add new page',
    deleteTitle: 'Are you sure you want to delete this page?',
    managePage: 'Manage Tabs',
    empty: "This page don't have any block yet.",
    dragAndDrop: 'Drag and drop your other tabs to reorder them',
    pageNavigation: 'Page navigation settings',
    goToDesign: 'Go to Design settings',
    viewArchive: 'View archive',
    archivedBlocks: 'Archived blocks',
    noArchivedBlocks: "Keep your page clean and focused by archiving blocks you're not currently using.",
    archiveAllUnpublished: 'Archive all unpublished blocks',
    restore: 'Restore',
    permanentDelete: 'Delete permanently',
  },
  analytics: {
    lifeTimeAnalytics: 'Lifetime Analytics',
    impressions: 'Impressions',
    impressionsText: 'Performance of the impressions stats for the chosen period',
    clicks: 'Clicks',
    clicksText: 'Performance of "click" events for the chosen period',
    signUps: 'Sign-Ups',
    signUpsText: 'Performance of "close" events for the chosen period',
    totalInteractions: 'Total Interactions',
    totalInteractionsText: 'Total clicks and form sign-ups for the chosen period',
    engagementRate: 'Engagement Rate',
    engagementRateText: 'Share of profile views that led to an interaction',
    visitor: 'Visitor Sources',
    country: 'Country',
    countries: 'Countries',
    linkClicks: 'Link clicks',
    content: 'Content',
    views: 'Views',
  },
  aiInsights: {
    title: 'AI Insights',
    generate: 'Analyze my profile',
    description: 'Get AI-powered recommendations to improve your profile performance.',
    analyzing: 'Analyzing your profile...',
    refresh: 'Refresh',
    action: 'Action',
  },
  post: {
    subscriptionTypePlaceholder: `Available for 'type' subscription and above`,
    postButtonText: 'Post',
    newPostPlaceholder: 'What is on your mind',
    free: 'Free',
    pro: 'Pro',
    premium: 'Premium',
    noPost: `You don't have posts yet`,
    editPost: 'Edit post',
  },
  preview: {
    buy: 'Buy',
    connect: 'Connect',
  },
  activeButton: {
    initialText: 'Website',
    inputPlaceholder: 'Search actions...',
    existing: 'Existing',
    redirect: 'Redirect',
    scroll: 'Scroll',
    title: 'Active Button',
    modalTitle: 'Active button action',
    subtitle: 'Button that motivates the user to take an action',
    next: 'Next',
    save: 'Save',
    opensALinkFromLinksBlock: 'Opens a link from Links block',
    url: 'URL',
    opensAWebsite: 'Opens a website',
    openInApp: 'Open in App',
    addAction: 'Add Action',
    actionTitle: 'Action',
    actionCaption: 'Edit action type',
    chooseOption: 'Choose an option',
    tellPeople: 'Tell people how to engage with the action button',
    urlRedirect: 'URL Redirect',
    customUrl: 'Custom URL',
    customUrlText: 'Opens a website',
    links: 'Links',
    linksText: 'Opens a link from Links block',
    downloadDocument: 'Download Document',
    sendEmail: 'Send Email',
    opensEmailClient: 'Opens email client',
    phoneCall: 'Phone Call',
    initiatesPhoneCall: 'Initiates phone call',
    navigation: 'Navigation',
    openPage: 'Open Page',
    opensInternalPage: 'Opens internal page',
    openPageText: 'Opens internal page',
    openProduct: 'Open Product',
    openProductText: 'Opens product page from Store',
    openBlog: 'Open Blog',
    opensBlogPageFromStore: 'Opens blog page from Store',
    openBlock: 'Open Block',
    opensContentBlock: 'Opens content block',
    openItem: 'Open Item',
    opensItemPageFromStore: 'Opens item page from Store',
    showNewModal: 'Show New Modal',
    displayContentInModalWindow: 'Display content in modal window',
    showProduct: 'Show Product',
    displayProductInModalWindow: 'Display product in modal window',
    showBlog: 'Show Blog',
    scrollToBlock: 'Scroll to Block',
    scrollToBlockText: 'Scroll to the specified page block',
    scrollToItem: 'Scroll to Item',
    action: 'Action',
    showBlock: 'Show Block',
    showBlockText: 'Content block from Store',
    showItem: 'Show Item',
    showItemText: 'Opens item page from Store',
    linksCaption: 'Links',
    linksTooltip: 'Choose a link from links block',
    pagesCaption: 'Pages',
    pagesTooltip: 'Choose a page from pages',
    productsCaption: 'Products',
    productsTooltip: 'Choose a product from list',
    blocksCaption: 'Blocks',
    blocksTooltip: 'Choose a block from list',
    itemsCaption: 'Items',
    itemsTooltip: 'Choose an item from list',
    showProductText: 'Display the product within a modal window on the page',
    more: 'Show more',
    less: 'Show less',
    showNewModalTitle: 'New Modal Data',
    uploadDocumentTitle: 'Click to upload or drag and drop',
    uploadProgressTitle: 'Uploading...',
    haveNoModal: "You don't have modal",
    haveModal: 'You have selected modal',
    openNewModalHandler: 'Create new modal',
    linkGroupSubTitle: 'Select a block',
    linkItemSubTitle: 'Select a link',
    urlItemSubTitle: 'Website URL',
    openInAppItemSubTitle: 'App URL',
    sendEmailItemSubTitle: 'Email Address',
    phoneCallItemSubTitle: 'Phone Number',
    openPageGroupSubTitle: 'Select Page',
    openPageItemSubTitle: 'Select Page',
    openProductGroupSubTitle: 'Select Product Type',
    openProductItemSubTitle: 'Select Product',
    openBlogGroupSubTitle: 'Select Blog Channel',
    openBlogItemSubTitle: 'Select Blog Article',
    openBlockGroupSubTitle: 'Select Page',
    openBlockItemSubTitle: 'Select Block',
    openItemGroupSubTitle: 'Select Block',
    openItemItemSubTitle: 'Select Item',
    showProductGroupSubTitle: 'Select Product Type',
    showProductItemSubTitle: 'Select Product',
    showBlogGroupSubTitle: 'Select Blog Channel',
    showBlogItemSubTitle: 'Select Blog Article',
    showBlockGroupSubTitle: 'Select Page',
    showBlockItemSubTitle: 'Select Block',
    showItemGroupSubTitle: 'Select Block',
    showItemItemSubTitle: 'Select Item',
    scrollToBlockGroupSubTitle: 'Select Page',
    scrollToBlockItemSubTitle: 'Select Block',
    scrollToItemGroupSubTitle: 'Select Block',
    scrollToItemItemSubTitle: 'Select Item',
    linkGroupPlaceholder: 'Choose a block...',
    linkItemPlaceholder: 'Choose a link...',
    openPageItemPlaceholder: 'Choose a page...',
    openProductGroupPlaceholder: 'Choose a product type...',
    openProductItemPlaceholder: 'Choose a product...',
    showProductGroupPlaceholder: 'Choose a product group...',
    showProductItemPlaceholder: 'Choose a product...',
    openBlogGroupPlaceholder: 'Choose a blog channel...',
    openBlogItemPlaceholder: 'Choose a blog article...',
    openBlockGroupPlaceholder: 'Choose a page...',
    openBlockItemPlaceholder: 'Choose a block...',
    openItemGroupPlaceholder: 'Choose a page and block...',
    openItemItemPlaceholder: 'Choose an item...',
    showBlogGroupPlaceholder: 'Choose a blog group...',
    showBlogItemPlaceholder: 'Choose a blog post...',
    showBlockGroupPlaceholder: 'Choose a page...',
    showBlockItemPlaceholder: 'Choose a block...',
    showItemGroupPlaceholder: 'Choose a page and block...',
    showItemItemPlaceholder: 'Choose an item...',
    scrollToBlockGroupPlaceholder: 'Choose a page...',
    scrollToBlockItemPlaceholder: 'Choose a block...',
    scrollToItemGroupPlaceholder: 'Choose a page and block...',
    scrollToItemItemPlaceholder: 'Choose an item...',
    linkReadable: 'Link',
    urlReadable: 'Url',
    openInAppReadable: 'Open in App',
    downloadDocumentReadable: 'Download Document',
    sendEmailReadable: 'Send Email',
    phoneCallReadable: 'Phone Call',
    openPageReadable: 'Open Page',
    openProductReadable: 'Open Product',
    showNewModalReadable: 'Show New Modal',
    showProductReadable: 'Show Product',
    openBlogReadable: 'Open Blog',
    openBlockReadable: 'Open Block',
    openItemReadable: 'Open Item',
    showBlogReadable: 'Show Blog',
    showBlockReadable: 'Show Block',
    showItemReadable: 'Show Item',
    scrollToBlockReadable: 'Scroll to Block',
    scrollToItemReadable: 'Scroll to Item',
  },
  design: {
    tabs: 'Tabs',
    imageView: 'Image view',
    preview: 'Preview',
    buttonOpacity: 'Button opacity',
    buttonBorder: 'Button border',
    buttonShadow: 'Button shadow',
    itemView: 'Item view',
    itemViewTooltip: 'Choose item view',
    itemLayout: 'Item layout',
    itemLayoutTooltip: 'Choose item layout',
    top: 'Top',
    center: 'Center',
    bottom: 'Bottom',
    bottomLeft: 'Bottom Left',
    bottomHorizontal: 'Bottom Horizontal',
    under: 'Under',
    title: 'Title',
    titleButton: 'Title & Button',
    displayOptions: 'Display options',
    displayOptionsTooltip: 'Choose display options',
    landscape: 'Landscape',
    square: 'Square',
    portrait: 'Portrait',
    desktopMode: 'Desktop mode',
    mobile: 'Compact',
    desktop: 'Wide',
    responsive: 'Responsive',
    custom: 'Custom',
    templates: 'Templates',
    chooseTemplates: 'Choose your templates',
    viewAll: 'View all',
    previousTheme: 'Please note that the previous theme will be permanently erased.',
    useThisTemplate: 'Use this template',
    notSupportedVideo: 'Your browser does not support the video tag.',
    photosBy: 'Photos by',
    animationBy: 'Animation by',
    searchTheSame: 'Search the same term again for different results.',
    addImage: 'Add an image',
    addVideo: 'Add an video',
    orSelectFrom: 'or select from',
    noImagesYet: 'No images yet',
    noVideosYet: 'No videos yet',
    videoBy: 'Video by',
    hamburgerMenu: 'Hamburger menu',
    tabsOnTop: 'Tabs on top',
    tabsOnBottom: 'Tabs on bottom',
    borderType: 'Border type',
    subTitle: 'Choose shape, border type, shadow etc.',
    icon: 'Icon',
    iconTooltip: 'Choose right icon to your button',

    background: 'Background',
    color: 'Color',
    backgroundOpacity: 'Background opacity',
    backgroundOpacityTooltip: 'Drag slider to set background opacity',
    gradient: 'Gradient',
    color1: 'Color 1',
    color2: 'Color 2',
    direction: 'Direction',
    directionTooltip: 'Drag slider to set direction of a gradient',
    offset: 'Offset',
    offsetTooltip: 'Drag slider to set offset of a gradient',
    minHeight: 'Minimum height',
    minHeightTooltip: 'Drag the slider to change the minimum height of the button',
    align: 'Align',
    alignTooltip: 'Change button position',

    insert: 'Insert URL',
    upload: 'Upload video',
    search: 'Search video',

    layout: 'Layout',
    layoutTooltip: 'Choose the layout you want',
    view: 'View',
    viewTooltip: 'Choose the view you want',
    media: 'Media',
    mediaTooltip: 'Choose the media you want',

    none: 'None',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    round: 'Round',

    feed: 'Feed',
    slider: 'Slider',

    text: 'Text',
    colorTooltip: 'Choose colors',
    button: 'Button',
    buttonTooltip: 'Choose button colors',
    chooseEmoji: 'Choose emoji',
    changeEmoji: 'Change your emoji',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Add link',
      addVideo: 'Add video',
      addProduct: 'Add product',
      addPost: 'Add post',
      addArticle: 'Add article',
      addPhoto: 'Add photo',
      addMusic: 'Add music',
      addFiles: 'Add files',
      addStory: 'Add story',
    },
    emoji: {
      search: 'Search',
      clear: 'Clear',
      notfound: 'No Emoji Found',
      skintext: 'Choose your default skin tone',
      categories: {
        search: 'Search Results',
        recent: 'Frequently Used',
        smileys: 'Smileys & Emotion',
        people: 'People & Body',
        nature: 'Animals & Nature',
        foods: 'Food & Drink',
        activity: 'Activity',
        places: 'Travel & Places',
        objects: 'Objects',
        symbols: 'Symbols',
        flags: 'Flags',
        custom: 'Custom',
      },
      categorieslabel: 'Emoji Categories',
      skintones: {
        1: 'Default Skin Tone',
        2: 'Light Skin Tone',
        3: 'Medium-Light Skin Tone',
        4: 'Medium Skin Tone',
        5: 'Medium-Dark Skin Tone',
        6: 'Dark Skin Tone',
      },
    },
    blogPreviewModal: {
      title: 'Blog Preview',
      notify: 'Notify subscribers',
    },
    standAloneModal: {
      title: 'Link Preview',
      save: 'Save',
      chooseLayout: 'Choose a layout for your link',
      linkSettings: 'Link Settings',
      linkSettingsSubtitle: 'Redirect, appearance',
      whenVisitorsClicks: 'When a visitor clicks this link:',
      redirect: 'Redirect',
      redirectText: 'Send visitors directly to the URL',
      highlight: 'Highlight',
      highlightText: 'Send visitors to your UniLink and highlight',
      standalone: 'Standalone',
      standaloneText: 'Make your YouTube link stand out and have the content play right on your',
      cover: 'Cover',
      imageTab: 'Image',
      videoTab: 'Video',
      uploadImage: 'Upload image',
      whenVisitors: 'When a visitor selects the shared link:',
      compact: 'Compact view',
      fullView: 'Full view',
      videoSound: 'Play video with sound',
    },
    instagramModal: {
      title: 'Send automatic Instagram DMs',
      subtitle: 'Send this link via direct message when someone comments on your IG post or Reel',
      promo: "Choose which IG you'd like to send from",
      connect: 'Connect Instagram account',
      added: 'Instagram account added',
      addNew: 'Add new automation',
      igContent: 'IG content',
      trigger: 'Trigger',
      dmContent: 'DM',
      linkDestination: 'Link Destination',
      buttonTitle: 'Button title',
      buttonTitleTooltip: 'Enter button title',
      directMessage: 'Direct message',
      directMessageTooltip: 'Enter direct message',
      selectPosts: 'Select the post or Reel that will trigger your automatic DM.',
      onePost: 'One specific post or Reel',
      allPosts: 'All posts or Reels',
      triggerText: 'When comments include this, your DM will send.',
      addMessage: 'Add a message to send automatically with your link.',
      clickLink: 'When someone clicks the link in your DM:',
      anyComment: 'Any comment',
      specificKeywords: 'Comments with specific keywords',
      sendLink: 'Send them to your UniLink and highlight ',
      skipLink: 'Skip UniLink and send them straight',
      keywordsTitle: 'Comments with specific keywords',
      keywordsText: 'Your DMs will be sent when comments include or exclude\n' + 'specific keywords (not case-sensitive):',
      keywordsPlaceholder: 'Type a keyword',
      keywordsExclude: 'Exclude keywords',
      keywordsExcludeText: 'Must exclude any of these',
      replyComment: 'Reply comment',
      replyCommentTooltip: 'Enter reply comment',
    },
    blockEditProduct: {
      productPreview: 'Thumbnail',
      productDetails: 'Details',
      settings: 'Settings',
      design: 'Design',
    },
    editMenuItems: {
      overview: 'Overview',
      analytics: 'Analytics',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Enter token of your bot',
      connect: 'Connect',
      token: 'Token',
    },
    rewards: {
      title: 'Title',
      titleTooltip: 'Enter title for response',
      text: 'Text',
      textTooltip: 'Enter text for response',
      link: 'Link',
      linkTooltip: 'Enter link for response',
      code: 'Code',
      codeTooltip: 'Enter code for response',
      files: 'Files',
      filesTooltip: 'Enter files for response',
      removeReward: 'Are you sure you want to remove this response?',
    },
    addRewardModal: {
      addReward: 'Add Response',
      textTitle: 'Text',
      textText: 'Give access to instruction or any text with Rich Editor',
      fileTitle: 'Files',
      fileText: 'Give access to files and collect contact details',
      linkTitle: 'Link',
      linkText: 'Give access to exclusive content and collect contact details',
      codeTitle: 'Code',
      codeText: 'Give access to exclusive promotions and collect contact details',
    },
    blockEmpty: {
      isNotAdded: `isn't added`,
      itSeems: `It seems like your`,
      itemsNot: `items aren't added yet. Add your videos now`,
      add: 'Add',
    },
    blockList: {
      add: `Add`,
      item: 'item',
    },
    submitAction: {
      action: 'Action (after submitting)',
      actionTooltip: 'Choose an action after submitting',
      upload: 'Upload attachments',
      none: 'None',
      page: 'Show Confirmation Page',
      email: 'Send Confirmation Email',
      redirect: 'Redirect to URL',
    },
    blockEditItem: {
      content: 'Content',
      preview: 'Preview',
      settings: 'Settings',
    },
    domainButton: {
      customizeDomain: 'Customize your domain.',
      upgradeToLink: 'Upgrade to Link in Bio Pro and use a custom domain.',
    },
    coverText: {
      text: 'Text',
      textTooltip: 'Enter text to your cover',
      description: 'Description',
      descriptionTooltip: 'Enter description to your cover',
      textColor: 'Text color',
    },
    itemModal: {
      edit: 'Edit',
      addNew: 'Add new',
      item: 'item',
      update: 'Update',
      add: 'Add',
    },
    viewDesign: {
      compact: 'Compact',
      card: 'Card',
      button: 'Button',
      list: 'List',
      hero: 'Hero',
      compact: 'Compact',
      featured: 'Featured',
    },
    moveItemModal: {
      title: 'Move item to another page',
      cancel: 'Cancel',
      move: 'Move',
      page: 'Page',
      pageTooltip: 'Choose a page for moving item',
      blocks: 'Blocks',
      blocksTooltip: 'Choose a block for moving item',
      emptyBlocks: 'There are no required blocks on this page.',
    },
    limitModal: {
      title: 'Limit reached',
      text1: "You have reached your site's limit.",
      text2: 'Please contact us to upgrade your plan.',
      close: 'Close',
    },
    cropPicture: {
      title: 'Crop your image',
      cancel: 'Cancel',
      save: 'Save',
    },
    uploadFile: {
      uploadProductImage: 'Upload product image',
      coverImage: 'Cover image',
      uploadImages: 'You can only upload images here',
    },
    userMediaLibrary: {
      addImage: 'Add an image',
      uploadImage: 'Upload image',
      orSelectFrom: 'or upload',
      orSelectLink: 'or paste link',
      myMedia: 'My Media',
      stockImages: 'Stock Images',
      gifs: 'GIFs',
      icons: 'Icons',
      noImagesYet: 'No images yet',
      loadMore: 'Load more',
    },
    itemMenu: {
      active: 'Active',
      willBeAvailable: 'The item will be available at:',
      save: 'Save',
      copied: 'Copied',
      copyLink: 'Copy link',
      delete: 'Delete',
    },
    itemDesign: {
      linkColor: 'Link color',
      gradient: 'Gradient',
      background: 'Background',
      backgroundOpacity: 'Background opacity',
      backgroundOpacityTooltip: 'Drag slider to set background opacity',
      backgroundDarkness: 'Background darkness',
      backgroundDarknessTooltip: 'Drag slider to set background darkness',
      text: 'Text',
      color1: 'Color 1',
      color2: 'Color 2',
      direction: 'Direction',
      directionTooltip: 'Drag slider to set direction of a gradient',
      offset: 'Offset',
      offsetTooltip: 'Drag slider to set offset of a gradient',
      linkHeight: 'Link height',
      linkHeightTooltip: 'Drag the slider to change the height of the button',
      icon: 'Icon',
      iconTooltip: 'Choose icon to your button',
      imageShape: 'Image Shape',
      imageShapeTooltip: 'Choose image shape to your link',
    },
    menu: {
      linkInBio: 'Link in bio',
      linkInBioApps: 'Link in Bio',
      posts: 'Posts',
      audience: 'Audience',
      orders: 'Orders',
      marketing: 'Marketing',
      emailMarketing: 'Email Marketing',
      socialPlanner: 'Social Planner',
      shortLinks: 'Short Links',
      recentProfiles: 'Recent Profiles',
      // messages: 'Messages',
      standalonePage: 'Standalone Page',
      soloApps: 'App in Bio',
      bots: 'Bots',
      smartReply: 'Smart Reply',
      analytics: 'Analytics',
      settings: 'Settings',
      shop: 'Earn',
      publish: 'Publish',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'QR Codes',
      singlePages: 'Apps',
      forms: 'Forms',
      form: 'Forms',
      automations: 'Automations',
      community: 'Community',
      messages: 'Inbox',
      agents: 'Agents',
      apps: 'Apps',
    },
    notificationsBlockSetting: {
      title: 'Notifications',
      setUp: 'Set up',
      notifications: 'notifications',
      connect: 'Connect',
      telegramText: 'Receive telegram notification when someone makes',
      change: 'change',
      email: 'Email',
      emailText: 'Receive an email when someone makes',
      webhook: 'Webhook',
      webhookTooltip: 'Add webhook',
      activate: 'Activate',
      webhookText: 'Send event to 3d party website when someone makes',
      webhookURL: 'Webhook URL (POST request)',
      error: 'Enter correct link',
      save: 'Save',
    },
    navigation: {
      content: 'Content',
      pages: 'Pages',
      posts: 'Posts',
      shop: 'Store',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Settings',
      apps: 'Apps',
      store: 'Store',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analytics',
      settings: 'Settings',
      editTabs: 'Edit Tabs',
    },
    unlockModal: {
      title: 'Unlock Pro Features',
      text: 'Get more from your link-in-bio. Just $5/month — unlock everything Pro has to offer:',
      checkBoxTitle1: 'More Blocks:',
      checkBoxText1: 'Add forms, stores, countdowns & media players',
      checkBoxTitle2: 'Advanced Analytics:',
      checkBoxText2: 'Track clicks, views & audience insights',
      checkBoxTitle3: 'Custom Domain:',
      checkBoxText3: 'Use your own domain for a professional look',
      checkBoxTitle4: 'Built-In Store:',
      checkBoxText4: 'Sell products and manage orders with ease',
      checkBoxTitle5: 'SEO Tools:',
      checkBoxText5: 'Rank higher with meta tags, UTM & custom slugs',
      checkBoxTitle6: 'Integrations:',
      checkBoxText6: 'Sync with Mailchimp, Zapier & other tools',
      checkBoxTitle7: 'Email Marketing:',
      checkBoxText7: 'Collect leads & send automated campaigns',
      checkBoxTitle8: 'Priority Support:',
      checkBoxText8: 'Get faster help whenever you need it',
      upgradeToPro: 'Upgrade to Pro',
      viewAllPlans: 'View all plans',
    },
    profileSwitcher: {
      title: 'All Profiles',
      button: 'Add a new profile',
    },
    account: {
      signOut: 'Sign out',
      createNew: 'Create a new Link in Bio',
      tryPro: 'Try Pro now!',
      tryProText: 'Get advanced customization and deeper audience insights to get more visitors!',
    },
    accountSettings: {
      title: 'Account settings',
    },
    billingHistory: {
      title: 'Billing history',
    },
    pages: {
      home: 'Home',
      newPage: 'New Page',
      managePages: 'Manage Pages',
    },
    blockItem: {
      actionRequired: 'action required',
    },
    blockContent: {
      untitled: 'Untitled',
      clickToRename: 'Click to rename subtitle',
      saving: 'saving',
      saved: 'saved',
      deleteTitle: 'Are you sure you want to delete this block?',
      cancel: 'Cancel',
      yes: 'Yes',
    },
    addButtonModal: {
      title: 'Add an action button',
      close: 'Close',
      added: 'Added',
      add: 'Add',
      messageTitle: 'Message',
      messageText: 'Message button allows users contact you via messenger',
      subscribeTitle: 'Subscribe',
      subscribeText: 'Subscribe button allows users subscribe to you email or messenger list',
      ctaTitle: 'CTA button',
      ctaText: 'CTA is a prompt on a website that tells the user to take specified action',
      cartTitle: 'Cart',
      cartText: 'Display a shopping cart icon to indicate that visitors can make purchases on your website',
      contactTitle: 'Contact',
      contactText: 'Enable visitors to quickly access your contact information',
      qrcodeTitle: 'QR Code',
      qrcodeText: 'Display a QR code so visitors can quickly scan and share your page',
      languageTitle: 'Language',
      languageText: 'Allow visitors to switch the language of your page',
    },
    inputMask: {
      copyLink: 'Copy link',
    },
    videoLibrary: {
      addVideo: 'Add video',
      myVideos: 'My Videos',
      stockVideos: 'Stock Videos',
      pasteUrl: 'Paste URL',
      uploadVideo: 'Upload Video',
    },
    createBlockModal: {
      searchTitle: 'Pick a block to add to your page',
      title: 'Add to UniLink',
      contentTitle: 'Content',
      contentText: 'Create and manage your page',
      growTitle: 'Leads',
      growText: 'Collect leads and boost engagement',
      monetizeTitle: 'Monetize',
      monetizeText: 'Sell products, content and services',
      monetizationTitle: 'Make and collect money',
      monetizationText: 'Sell products, services and collect tips',
      socialTitle: 'Social media content',
      socialText: 'Share social media content on your UniLink',
      toolsTitle: 'Growth tools',
      toolsText: 'Grow, manage, and connect with your audience',
      search: 'Search',
      all: 'All',
      allCategories: 'All categories',
      content: 'Content',
      monetization: 'Monetization',
      social: 'Social',
      tools: 'Tools',
      header: 'Header',
      headerText: 'Add a profile picture and bio',
      link: 'Links',
      linkText: 'Select link layout',
      text: 'Text',
      textText: 'Select text layout',
      videos: 'Videos',
      videosText: 'Select video type',
      image: 'Image',
      imageText: 'Add image blocks',
      music: 'Music',
      musicText: 'Select music type',
      socialFeeds: 'Social Feeds',
      socialFeedsText: 'Select social feed type',
      moreContent: 'More',
      moreContentText: 'Add more content blocks',
      dataCollect: 'Data Collect',
      dataCollectText: 'Select data collect type',
      form: 'Form',
      formText: 'Select form type',
      conversionTools: 'Engagement tools',
      conversionToolsText: 'Add conversion blocks',
      products: 'Products',
      productsText: 'Add product blocks',
      donation: 'Tips & Donations',
      tipsAndDonations: 'Tips & Donations',
      tipsDonationsText: 'Tips and donation blocks',
      event: 'Event',
      eventText: 'Select event type',
      quickAdd: 'All blocks',
      quickAddText: 'Add any block',
    },
    addBlockModal: {
      title: 'Add to UniLink',
      dragToAdd: 'Drag to add',
      contentTitle: 'Share basic content',
      contentText: 'Share content directly on your UniLink',
      monetizationTitle: 'Make and collect money',
      monetizationText: 'Sell products, services and collect tips',
      socialTitle: 'Social media content',
      socialText: 'Share social media content on your UniLink',
      toolsTitle: 'Growth tools',
      toolsText: 'Grow, manage, and connect with your audience',
      search: 'Search',
      searchPlaceholder: 'Search content...',
      all: 'All',
      allCategories: 'All categories',
      content: 'Content',
      monetization: 'Monetization',
      social: 'Social',
      tools: 'Tools',
    },
    tabNavigation: {
      tabView: 'Tab view',
      tabViewTooltip: 'Select tab view for navigation',
      colors: 'Colors',
      colorsTooltip: 'Choose colors of posts and buttons',
      tabs: 'Tabs',
      tabsTooltip: 'Choose tabs that shows in website navigation',
      content: 'Content',
      posts: 'Posts',
      store: 'Store',
      shop: 'Store',
      tabsSettings: 'Tabs navigation settings',
    },
    hideLogo: {
      text: 'Show UniLink logo in the footer of your page.',
      text2: 'Show UniLink logo in the footer of your page.',
    },
    palettePreview: {
      custom: 'Custom Background Color',
      hexColor: 'Hex color',
      hexColorTooltip: 'Enter hex color of your preview',
    },
    backgroundVideo: {
      insert: 'Insert URL',
      upload: 'Upload video',
      search: 'Search video',
    },
    periodDropdown: {
      today: 'Today',
      yesterday: 'Yesterday',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      allTime: 'All time',
      custom: 'Custom',
    },
    subsections: {
      content: 'Content',
      design: 'Desing',
      settings: 'Settings',
    },
    wrapperSettings: {
      lock: 'Update to PRO Plan',
    },
    shareModal: {
      addSocials: 'Add to Socials',
      shareTo: 'Share to',
      qrCode: 'QR code',
      customizeUrl: 'Customize URL',
      goToMy: 'Go to my',
      print: 'You can print your unique qr code on',
      cards: 'business cards and flyers',
      download: 'Download',
      copy: 'Copy',
      previewMobile: 'Preview on mobile',
      scanMobilePreview: 'Scan QR code on your mobile device to preview your website',

      types: {
        socials: 'socials',
        shareTo: 'share',
        qrCode: 'QR',
        title: 'Share your UniLink',
        titleSocials: 'Add UniLink to your socials',
        titleShareTo: 'Share to...',
        titleQRCode: 'QR Code',
        titlePreviewMobile: 'Preview on Mobile',
      },
      socialList: {
        instagramText: 'Add your UniLink to your Instagram profile. Simply copy your UniLink URL, go to Edit Profile, and paste it into the Website field.',
        facebookText:
          'Add your UniLink to your Facebook profile. Simply copy your UniLink URL, go to the About page on your profile, click on Contact and basic info, then click on + Add a website, paste your UniLink URL into the Website address field, and click Save.',
        tikTokText:
          'Add your UniLink to your Facebook profile. Simply copy your UniLink URL, go to the About page on your profile, click on Contact and basic info, then click on + Add a website, paste your UniLink URL into the Website address field, and click Save.',
        twitchText:
          'Add your UniLink to your Twitch channel. Simply copy your UniLink URL, go your Twitch channel, click About, then click Edit about & links settings, scroll down to Social Links, add UniLink in the first text field, and paste your UniLink URL into the second text field, then click Add.',
        youTubeText:
          'Add your UniLink to your YouTube channel. Simply copy your UniLink URL, go to your YouTube channel, click on Customize Channel, then click on Basic info, and under Links, add a link title and paste your UniLink URL into the URL field, then click Publish.',
        linkedInText:
          'Add your UniLink to your LinkedIn profile. Simply copy your UniLink URL, go your LinkedIn profile, click on pencil icon, scroll down to Contact info, paste your UniLink URL into the Website URL field, then click Apply.',
        pinterestText:
          'Add your UniLink to your Pinterest profile. Simply copy your UniLink URL, go your Pinterest settings, paste your UniLink URL into the Website URL field, then click Save.',
        twitterText: `Add your UniLink to your Twitter profile. Simply copy your UniLink URL, go to your profile, click on Edit Profile, and paste your UniLink URL into the Website field.`,
      },
      share: {
        shareFacebook: 'Share on Facebook',
        shareLinkedIn: 'Share on LinkedIn',
        shareTwitter: 'Share on Twitter',
        shareWhatsApp: 'Share via WhatsApp',
        shareMessenger: 'Share via Messenger',
        shareEmail: 'Share via Email',
      },
    },
  },
  popupMenu: {
    edit: 'Edit page',
    openInNewTab: 'Open in new tab',
    copyLink: 'Copy URL',
    delete: 'Delete',
    showThumbnail: 'Show page thumbnails in dashboard',
    manageTabs: 'Manage Tabs',
  },
  tabsDashboard: {
    labelAddNewTab: 'New Tab',
  },
  blocks: {
    header: {
      blockTitle: 'Header',
      blockText: 'Customize your profile picture, add a short bio, and update your social icons',
      blockShortText: 'Customize your profile',
      layout: 'Layout',
      layoutTooltip: 'Create the header layout you want',
      layoutAlign: 'Layout align',
      layoutAlignTooltip: 'Align text',
      profilePicture: 'Profile picture',
      profilePictureTooltip: 'Change your profile picture',
      pictureSize: 'Picture size',
      pictureSizeTooltip: 'You can change picture size',
      pictureHeight: 'Picture height',
      pictureHeightCaption: 'You can change picture height',
      preview: 'Preview',
      badge: 'Badge',
      badgeTooltip: 'Add a verified badge to header',
      tags: 'Tags',
      tagsTooltip: 'Show category tags under your name (up to 5)',
      tagsAdd: 'Add tags',
      addTags: '+ Add tags',
      tagsEdit: 'Edit tags',
      tagsCustomPlaceholder: 'Add custom tag',
      tagsCustomAdd: 'Add',
      tagsSuggested: 'Suggested categories',
      tagsSelected: 'Selected',
      tagsEmpty: 'No tags yet — pick from suggestions or add your own',
      tagsLimit: 'Max 5 tags',
      visibility: 'Visibility',
      visibilityTooltip: 'Show or hide profile picture',
      cover: 'Cover',
      coverTooltip: 'Add image or video to header cover',
      addCover: 'Add cover',
      image: 'Image',
      video: 'Video',
      positionCover: 'Text and button position',
      positionCoverTooltip: 'Drag slider to change position',
      buttons: 'Buttons',
      block: 'Block',
      videoProcessing: 'Video processing',
      vibe: 'Vibe',
      vibeTooltip: 'Add your vibe',
      stories: 'Stories',
      storiesTooltip: 'Add your stories',
      addStory: 'Add story',
      storiesSubtitle: 'Add image or video to your stories',
      subscribeMethod: 'Subscribe method',
      subscribeMethodTooltip: 'Choose your subscribe method',
      subscribeLink: 'Subscribe link',
      subscribeLinkTooltip: 'Copy your subscribe link',
      minWidth: 'Minimum width',
      addVCard: 'Add VCard',
      vCard: 'VCard',
      vCardTooltip: 'You can add info about yourself',
      buttonInline: 'Button inline header',
      buttonInsideContact: 'Button inside Contact button',
      showSaveContact: 'Display save contact',
      needAddContact: 'You need to add Contact button',
      socialGap: 'Gap',
      socialGapCaption: 'You can change the gap',
      socialSize: 'Size',
      socialSizeCaption: 'You can change the size',
      icons: 'Icons',
      iconsTooltip: 'Add icon to button',
    },
    text: {
      blockTitle: 'Text',
      blockText: 'General text block to write anything you want. You can format your text with WYSIWYG editor',
      blockShortText: 'General text block',
      title: 'Title',
      titleText: 'Customize your title size',

      orderOfElements: 'Order of elements',
      orderOfElementsTooltip: 'Drag slider to change order of elements',
      changeOrder: 'Change order',
      text: 'Text',
      content: 'Content',
      image: 'Image',
      button: 'Button',
      addButtons: 'Add more buttons',
      displayedContent: 'Displayed content',
      displayedContentTooltip: 'Show or hide content',
      buttonLayout: 'Button layout',
      buttonLayoutTooltip: 'Choose vertical or horizontal button arrangement',
    },
    timeline: {
      blockTitle: 'Timeline',
      blockText: 'Display a vertical timeline with events. Each event can have date/time, title, description, and optional image',
      blockShortText: 'Display events timeline',
      editItem: 'Edit event',
      title: 'Title',
      titlePlaceholder: 'Event title',
      subtitle: 'Subtitle',
      subtitlePlaceholder: 'Role or affiliation (optional)',
      description: 'Description',
      descriptionPlaceholder: 'Event description (optional)',
      startTime: 'Start time',
      endTime: 'End time',
      startDate: 'Start date',
      endDate: 'End date',
      showEndDate: 'Show end date',
      showEndDateTooltip: 'Turn off for ongoing events (e.g. "working here since 2023")',
      includeTime: 'Include time',
      includeTimeTooltip: 'If off, only the date will be shown without time',
      image: 'Image',
      imagePlaceholder: 'Upload avatar or icon',
      imageUploadFailed: 'Image could not be uploaded. Use My Media or paste link.',
      untitled: 'Untitled',
      listLayout: 'List layout',
      lineColor: 'Line color',
    },
    trust: {
      blockTitle: 'Trust',
      blockShortText: 'Share your partnerships',
      blockText: 'Place all your connections in one place.',
      titleText: 'Customize your title size',
      orderOfElements: 'Order of elements',
      orderOfElementsTooltip: 'Drag slider to change order of elements',
      changeOrder: 'Change order',
      text: 'Text',
      content: 'Content',
      image: 'Image',
      button: 'Button',
      displayedContent: 'Displayed content',
      displayedContentTooltip: 'Show or hide content',
      enterTrustLink: 'Enter Partner`s URL',
      enterTrustLinkTooltip: 'Paste Partner`s URL',
      enterPartnerName: 'Enter partner name',
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: 'Enter description (optional)',
      partnerLogo: 'Partner Logo',
      uploadPartnerLogo: "Upload your partner's logo",
    },
    link: {
      blockTitle: 'Links',
      blockText: 'Drive traffic to your website, blog, online store, or any other web pages',
      blockShortText: 'Drive traffic to website',
      addLink: 'Add link',
      addNewLink: 'Add new link',
      viewArchive: 'View archive',
      archivedLinks: 'Archived links',
      noArchivedLinks: "Keep your link admin clean and focused by archiving links you're not currently using.",
      archiveAllUnpublished: 'Archive all unpublished links',
      addFormExisting: 'Add from existing links',
      addYourLink: 'Add your link to the group',
      add: 'Add',
      otherTypes: 'Action type',
      link: 'Link',
      navigate: 'Navigate',
      navigateTo: 'Navigate to',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Page',
      navigateProduct: 'Product',
      navigateBlock: 'Block',
      modal: 'Modal',
      showModal: 'Show Modal',
      modalBlock: 'Show Block',
      modalItem: 'Show Item',
      modalCustom: 'Custom',
      document: 'Document',
      privat24: 'Privat24',
      phone: 'Phone Call',
      viber: 'Open Viber',
      skype: 'Open Skype',
      email: 'Send Email',
      discount: 'Discount',
      smartLink: 'Smart Link',
      mobileApp: 'Deep Link',
      enterURL: 'Enter URL',
      enterPrivat: 'Enter your card of Private Bank',
      enterPhone: 'Enter phone number',
      enterViber: 'Enter viber number',
      enterSkype: 'Enter skype',
      enterEmail: 'Enter email',
      enterTitle: 'Enter title',
      enterCopyText: 'Enter text to copy',
      enterPromoCode: 'Enter promo code',
      group: 'Create Group',
      content: 'Content',
      links: 'Links',
      heading: 'Heading',
      settings: 'Settings',
      thumbnail: 'Thumbnail',
      typeTooltip: '  Click will open this link',
      title: 'Title',
      titleTooltip: 'Name of your link',
      description: 'Description',
      descriptionTooltip: 'Optional description of link features, types, color, sizes, etc.',
      label: 'Label',
      labelTooltip: 'Add label name',
      button: 'Button',
      buttonTooltip: 'Add button name',
      buttonText: 'Button text',
      buttonTextTooltip: 'Name of your button',
      buttonUrl: 'Button URL',
      buttonUrlTooltip: 'Enter of button URL',
      addLinkToGroup: 'Add link to group',
      removeFromGroup: 'Remove from group',
      deletePermanently: 'Delete Permanently',
      image: 'Image',
      buttonBg: 'Button bg',
      postPreview: 'Post Preview',
      separatorType: 'Separator type',
      separatorTypeTooltip: 'Add separator type to your button',
      section: 'Section',
      sectionTooltip: 'Section of link',
      descriptionSeparator: 'Description',
      descriptionSeparatorTooltip: 'Optional description of section',
      sectionText: 'Section text',
      linkInstant: 'Link instant forwarding',
      spotlight: 'Spotlight the link',
      addEffect: 'Add special effect',
      countdown: 'Countdown',
      countdownTimer: 'Countdown timer',
      countdownText: 'Add a live countdown to when your link becomes clickable',
      chooseDate: 'Choose date',
      chooseDateTooltip: 'Choose date for your link',
      chooseAction: 'Choose action',
      chooseActionTooltip: 'Choose action for your link',
      addCountdown: 'Add countdown for link',
      scheduler: 'Scheduler',
      schedule: 'Schedule',
      scheduleText: 'Choose a date and time in the future for your link to activate',
      activateOn: 'Activate on',
      activateOnTooltip: 'Choose date',
      deactivateOn: 'Deactivate on',
      deactivateOnTooltip: 'Choose date',
      addSchedule: 'Add schedule for',
      scheduleError: 'End date cannot be earlier than start date and start date cannot be in the past.',
      scheduleErrorPast: 'Activation date cannot be in the past.',
      scheduleErrorPastDeactivate: 'Deactivation date cannot be in the past.',
      scheduleErrorOrder: 'Deactivation date must be after activation date.',
      activatesIn: 'Activates in',
      deactivatesIn: 'Deactivates in',
      lock: 'Lock',
      lockText: 'Visitors can only access this link by fulfilling one of the criteria.',
      lockCode: 'Code',
      lockCodeTitle: 'Code to unlock this link',
      lockCodeText: 'Visitors need to enter 4 digit code to unlock this link',
      lockSubscribe: 'Subscribe',
      lockSubscribeTitle: 'Visitors must subscribe to your UniLink to unlock the link.',
      lockSubscribeText: 'Lock has been configured successfully.',
      lockPayment: 'Payment',
      lockPaymentText: 'Lock has been configured successfully.',
      price: 'Price',
      priceTooltip: 'Add price of your product',
      lockAge: 'Date of birth (Age)',
      lockAgeTitle: 'Set minimum age',
      lockAgeText: 'Visitors need to be over a certain age to unlock the link with their date of birth',
      lockAgeAlert: 'Lock has been configured successfully.',
      lockSensitive: 'Sensitive content',
      lockSensitiveText: 'Visitors must acknowledge that this link may contain content that is not appropriate for all audiences.',
      makeLink: 'Make link payable',
      addLock: 'Add lock for link',
      save: 'Save',
      clear: 'Clear',
      buttonColor: 'Button color',
      labelColor: 'Label color',
      background: 'Background',
      imageHeight: 'Image height',
      imageHeightTooltip: 'Drag slider to change height of image',
      buttonMinimum: 'Minimum height',
      buttonMinimumTooltip: 'Drag slider to change height of button',
      textPosition: 'Text position',
      textPositionTooltip: 'Choose vertical position of text',
      preview: 'preview',
      defaultDesign: 'Default design',
      defaultDesignTooltip: 'Set up default design for links',
      defaultDesignTitle: 'Please note that this design will be applied to all links.',
      defaultDesignText: 'You can change the default link design',
      changeDefault: 'Change default',
      applyDefault: 'Apply default',
      scheduled: 'Scheduled',
      scheduledVisible: 'Scheduled link is now visible',
      scheduledHidden: 'Scheduled link is now hidden',
      linkClickable: 'Link clickable in',
      linkDisable: 'Link disable in',
      lockedBy: 'Locked by',
      items: 'Items',
      doNotAnyLinks: "You don't have any links yet",
      sublinks: 'Sublinks',
      layout: 'Layout',
      layoutTooltip: 'Choose the sublinks layout you want',
      hideGroupLink: 'Hide group link',
      rules: 'Rules',
      rulesText: 'Change the visibility of this link based on who is visiting your page.',
      rulesEmpty: 'No conditions yet. Add a condition to control who sees this link.',
      rulesAddCondition: 'Add condition',
      rulesActive: 'Visibility rules',
      rulesIf: 'If',
      rulesThen: 'Then',
      ruleTypeLocation: 'Location',
      ruleTypeDevice: 'Device',
      ruleTypeTime: 'Day & time',
      ruleOperatorIs: 'is',
      ruleOperatorIsNot: 'is not',
      ruleActionHide: 'Hide link',
      ruleActionShow: 'Show link',
      ruleSelectLocations: 'Select locations',
      ruleSearchLocations: 'Search countries…',
      ruleFrom: 'From',
      ruleTo: 'To',
      ruleAnyTime: 'Any',
    },
    'data-collect': {
      blockTitle: 'Data collect',
      blockText: 'Collect emails or phone numbers from your visitors',
      blockShortText: 'Collect emails',
      maxSize: 'You can add maximum 3 channels',
      customTerms: 'Custom T&Cs',
      customTermsTooltip: 'Add custom T&Cs to your form',
      termsConditions: 'Terms and Conditions',
      text: 'Text',
      subscribe: 'Subscribe',
      title: 'Title',
      titleTooltip: 'Enter title for terms and conditions',
      titleResultTooltip: 'Enter title for your submitting',
      url: 'URL',
      urlTooltip: 'Enter URL',
      editItem: 'Edit item',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Enter placeholder text',
      button: 'Button',
      buttonTooltip: 'Text that will motivate visitor to enter email (10% off discount, subscribe now, download file etc.)',
      successMessage: 'Success message',
      successMessageTooltip: 'Success message of your subscribes',
      botURL: 'Bot URL (optional)',
      botURLTooltip: 'Enter URL of your bot',
      botToken: 'Bot Token',
      botTokenTooltip: 'Enter token of your bot',
      rewards: 'Responses',
      rewardsTooltip: 'Add responses of your subscribes',
      addReward: 'Add response',
      thankYou: 'Thank you message',

      email: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response to Email',
        redirect: 'Redirect to URL',
      },
      phone: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response to Phone',
        redirect: 'Redirect to URL',
      },
      telegram: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Telegram bot',
        redirect: 'Redirect to URL',
      },
      whatsapp: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in WhatsApp bot',
        redirect: 'Redirect to URL',
      },
      instagram: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Instagram bot',
        redirect: 'Redirect to URL',
      },
      messenger: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Messenger bot',
        redirect: 'Redirect to URL',
      },
      viber: {
        none: 'None',
        display: 'Show Response instantly',
        send: 'Send Response in Viber bot',
        redirect: 'Redirect to URL',
      },
      connect: 'Connect',
      toChangeReward: 'To change response type you should remove the current one',
      remove: 'Remove',
      viewTypes: 'View Types',
    },
    form: {
      blockTitle: 'Form',
      blockText: 'Allows you to capture information and data from your audience',
      blockShortText: 'Capture information',
      fields: 'Fields',
      fieldsTooltip: 'Add fields to the form',
      addCustomField: 'Add custom field',
      addItem: 'Add item',
      editItem: 'Edit item',
      type: 'Type',
      typeTooltip: 'Choose type of field',
      string: 'Short answer',
      textarea: 'Long answer',
      dropdown: 'Dropdown',
      radio: 'Radio',
      checkbox: 'Checkbox',
      date: 'Date',
      time: 'Time',
      country: 'Country',
      fieldName: 'Field Name',
      fieldNameTooltip: 'Enter field name',
      name: 'Name',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Enter placeholder text',
      required: 'Required',
      requiredTooltip: 'Check if field is required',
      value: 'Value',
      enterTitle: 'Enter the title',
      addValue: 'Add value',
      delete: 'Delete',
      update: 'Update',
      add: 'Add',
      confirmationPage: 'Confirmation action',
      confirmationPageSubtitle: 'Choose result action after submitting form',
      successMessage: 'Success message',
      successMessageTooltip: 'Success message after submitting form',
      thankYou: 'Thank you message',
      submit: 'Submit',
    },
    contact: {
      blockTitle: 'Contacts',
      blockText: 'Contacts allows users to communicate with you directly. Add your phone, email, messenger, or location',
      blockShortText: 'Сommunicate with users',
      addNewContact: 'Add new contact',
      newContact: 'New contact',
      friendlyName: 'Friendly name',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Frequently Asked Questions — used to refer to a list of answers to typical questions that users might ask',
      blockShortText: 'Frequently Questions',
      addNewItem: 'Add new item',
      editItem: 'Edit item',
      title: 'Title',
      titleTooltip: 'Enter title',
      description: 'Description',
      descriptionTooltip: 'Enter description',
      update: 'Update',
      add: 'Add',
      howToFind: 'How to find us',
      view: 'View',
      viewTooltip: 'Choose how the FAQ items are displayed',
      feed: 'Feed',
      slider: 'Slider',
    },
    ama: {
      blockTitle: 'Ask Me Anything',
    },
    feature: {
      blockTitle: 'Features',
      blockText: 'Text section with image to tell your users why your business is the best',
      blockShortText: 'Tell your users why',
      title: 'Title',
      titleTooltip: 'Change title of item',
      description: 'Description',
      descriptionTooltip: 'Change description of item',
    },
    highlight: {
      blockTitle: 'Highlights',
      blockText: 'Highlight most important links with thumbnails (up to 3)',
      blockShortText: 'Highlight most important',
      title: 'Title',
      titleTooltip: 'Change title of item',
      url: 'URL',
      urlTooltip: 'Change URL of item',
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Feature image, video or your latest product to make it stand out. You can add CTA button to guide users towards your goal conversion',
      blockShortText: 'Feature image, video',
      height: 'Height',
      heightTooltip: 'Change height for banner',
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Image carousel that allows you to showcase your images content and add different features',
      blockShortText: 'Image carousel',
      image: 'Image',
      imageTooltip: 'Image of your gallery',
      addText: 'Add text',
      title: 'Title',
      titleTooltip: 'Title of your slide',
      titleSize: 'Title size',
      titleSizeTooltip: 'Choose size for better reading',
      description: 'Description',
      descriptionTooltip: 'Description of your slide',
      textColor: 'Text color',
      addButton: 'Add button',
      url: 'URL',
      urlTooltip: 'URL of your image',
      button: 'Button',
      buttonTooltip: 'Title of your button',
      buttonText: 'Button text',
      buttonColor: 'Button color',

      height: 'Height',
      heightTooltip: 'Change height for slides',
      view: 'View',
      viewTooltip: 'Choose view for slider',
      auto: 'Auto',
      square: 'Square',
      rectangle: 'Rectangle',
      single: 'Single',
      multi: 'Multi',
    },
    gallery: {
      blockTitle: 'Gallery',
      blockText: 'Image carousel that allows you to showcase your images content',
      blockShortText: 'Image carousel',
      image: 'Image',
      imageTooltip: 'Image of your gallery item',
      layout: 'Layout',
      layoutTooltip: 'Choose layout for gallery',
      feed: 'Feed',
      slider: 'Slider',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Create blog of your posts',
      blockShortText: 'Create blog',
      writeYourStory: 'Write your story',
      shortDescription: 'Short description',
      shortDescriptionTooltip: 'Optional description for your blog',
      description: 'Description',
    },
    map: {
      blockTitle: 'Map',
      blockText: 'Add Google map to help users navigate to your local business',
      blockShortText: 'Add Google map',
      buttonText: 'Button text',
      buttonTextTooltip: 'The button appears when the second view is selected',
      text: 'Text',
      addAddress: 'Add another address',
      address: 'Address',
      addressTooltip: 'Paste the address from google maps for example',
      googleMap: 'Google map (embed code)',
      googleMapTooltip: 'Paste the embed code from google maps',
      howToFind: 'How to find embed code',
      incorrectCode: 'Incorrect embed code.',
      moreInfo: 'More information',
      code: 'Code',
      addressSettings: 'Address settings',
      addressContent: 'Add URL, title and button text or icon',
      title: 'Title',
      titleTooltip: 'The name of your address',
      url: 'URL',
      urlTooltip: 'Paste the address URL from google maps for example',
      directionText: 'Direction text',
      directionTextTooltip: 'Call to action text for your users',
    },
    footer: {
      blockTitle: 'Footer',
      blockText: 'Section of content at the very bottom of a page. You can add contact information, social media icons, and an email sign-up form',
      blockShortText: 'Section of bottom content',
      addBlock: 'Add block',
      blockType: 'Block type',
      blockTypeTooltip: 'Choose block type',
      addBlockTitle: 'Block title',
      addBlockTitleTooltip: 'Choose title of block',
      faq: 'FAQ',
      'data-collect': 'Data Collect',
      contact: 'Contact',
      pages: 'Pages',
      payments: 'Payments',
      social: 'Social',
      cancel: 'Cancel',
      add: 'Add',
      None: 'None',
      link: 'link',
      faqText: 'You can edit frequently asked questions in FAQ block. You can navigate to it by clicking this',
      socialText: 'You can edit social icons in Header block. You can navigate to it by clicking this',
      dataCollectText: 'You can edit data-collect in Data Collect block. You can navigate to it by clicking this',
      contactText: 'You can edit contact in Contact block. You can navigate to it by clicking this',
      pagesText: 'You can add new pages on Website',
      paymentsText: 'Payments methods will be displayed',
      showOnAllpages: 'Show on all pages',
      footerText: 'The Footer from the Home page is currently enabled.',
      editSocialIcons: 'You can edit social icons in Header section. You can navigate to it by clicking this',
      editSubscribe: 'You can edit subscribe in Subscribe section. You can navigate to it by clicking this',
      editContacts: 'You can edit contacts in Contacts section. You can navigate to it by clicking this',
      editFrequently: 'You can edit frequently asked questions in FAQ section. You can navigate to it by clicking this',
    },
    'chat-ai': {
      blockTitle: 'AI Chat',
      blockShortText: 'Chat with AI',
      blockText: 'Chat with AI',
      suggestionsTitle: 'Suggestions',
      suggestionsSubtitle: 'Quick prompts',
      // writeYourStory: '',
      // shortDescription: '',
      // shortDescriptionTooltip: '',
      // description: '',
    },
    custom: {
      blockTitle: 'Custom',
      blockShortText: 'AI-powered micro app',
      blockText: 'Describe a mini interactive app and AI will generate it for you',
    },
    shop: {
      blockTitle: 'Shop',
      blockText: 'Add your product list',
      blockShortText: 'Add your products',
      view: 'View',

      products: 'Products',
      categories: 'Categories',
    },
    digital: {
      blockTitle: 'Digital products',
      blockText: 'Sell a Digital Download: PDFs, Spreadsheets, Templates, Exclusive',
      blockShortText: 'Sell a Digital',
    },
    podcast: {
      blockTitle: 'Podcasts',
      blockText: 'Promote your podcasts',
      blockShortText: 'Promote your podcasts',
    },
    'page-list': {
      blockTitle: 'Page list',
      blockText: 'Create your list pages',
      description: 'Description',
      blockShortText: 'Create your list pages',
      addNewPageItem: 'Add page link',
    },
    appointment: {
      blockTitle: 'Appointments',
      blockText: 'Let visitors book time on your calendar',
      blockShortText: 'Let visitors book',
    },
    service: {
      blockTitle: 'Services',
      blockText: 'You will receive an email notification when a request is submitted to you',
      blockShortText: 'Receive an email',
    },
    requests: {
      blockTitle: 'Services',
      blockText: 'You will receive an email notification when a request is submitted to you',
      blockShortText: 'Receive an email',
    },
    tips: {
      blockTitle: 'Tips',
      blockText: 'UniLink makes supporting fun and easy. In just a couple of taps, your fans can make the payment and leave a message',
      blockShortText: 'Makes supporting fun',
    },
    tip: {
      blockTitle: 'Tips',
      blockText: 'UniLink makes supporting fun and easy. In just a couple of taps, your fans can make the payment and leave a message',
      blockShortText: 'Makes supporting fun',
    },
    donation: {
      blockTitle: 'Donations',
      blockText: 'UniLink makes supporting fun and easy. In just a couple of taps, your fans can make the payment and leave a message',
      blockShortText: 'Makes supporting fun',
    },
    course: {
      blockTitle: 'Course or Tutorial',
      blockText: 'Let visitors book time on your calendar',
      blockShortText: 'Let visitors book',
    },
    event: {
      blockTitle: 'Events or Tickets',
      blockText: 'Let audience visit your events',
      blockShortText: 'Let audience visit',
    },
    menu: {
      blockTitle: 'Menu',
      blockText: 'Create a unique menu with prices',
      blockShortText: 'Create unique menu',
    },
    booking: {
      blockTitle: 'Booking',
      blockText: 'Let visitors book your spaces',
      blockShortText: 'Let visitors book',
      name: 'Name',
      nameCaption: 'Enter the name of the space',
      description: 'Description',
      descriptionCaption: 'Short description for this space',
      rentalType: 'Rental type',
      rentalTypeCaption: 'For example: apartment, car, office',
      duration: 'Duration',
      durationCaption: 'For example: per day, per week, per month',
      price: 'Price',
      priceCaption: 'Base price for this space',
      oldPrice: 'Old price',
      oldPriceCaption: 'Optional previous price',
      rating: 'Rating',
      ratingCaption: 'Average rating (optional)',
      label: 'Label',
      labelCaption: 'Short badge like HOT or NEW',
      image: 'Image',
      imageCaption: 'Upload a cover image for this space',
      location: 'Location',
      locationCaption: 'City, area or address',
      capacity: 'Capacity (guests)',
      capacityCaption: 'Maximum number of guests',
      rooms: 'Rooms & area',
      roomsCaption: 'Bedrooms, bathrooms and area',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      areaSqM: 'Area (m²)',
      minStay: 'Minimum stay (days)',
      minStayCaption: 'Minimum number of days for booking',
      requiresDeposit: 'Requires deposit',
      depositAmount: 'Deposit amount',
      depositAmountCaption: 'Upfront deposit to confirm booking',
      noSmoking: 'No smoking',
      noPets: 'No pets',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: 'Parking',
      amenitiesKitchen: 'Kitchen',
      amenitiesHeating: 'Heating',
      amenitiesAC: 'Air conditioning',
      amenitiesPool: 'Pool',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Restrooms',
      validationNameRequired: 'Name is required',
      validationPriceRequired: 'Price must be a non‑negative number',
      validationDepositRequired: 'Deposit amount is required when deposit is enabled',
      validationCapacityNumber: 'Capacity must be a non‑negative number',
      validationOldPriceNumber: 'Old price must be a non‑negative number',
      brand: 'Brand',
      brandCaption: 'Car brand, e.g. Tesla',
      model: 'Model',
      modelCaption: 'Car model, e.g. Model 3',
      year: 'Year',
      yearCaption: 'Year of manufacture',
      color: 'Color',
      colorCaption: 'Exterior color, e.g. black',
      fuelType: 'Fuel type',
      fuelTypeCaption: 'Gasoline, diesel, electric, hybrid etc.',
      transmission: 'Transmission',
      transmissionCaption: 'Automatic or manual',
      seatCount: 'Seat count',
      seatCountCaption: 'Number of seats in the car',
      edit: 'Edit item',
      add: 'Add item',
    },
    membership: {
      blockTitle: 'Membership',
      blockText: 'Create a free or paid subscription to your content',
      blockShortText: 'Create subscription',
    },
    pricing: {
      blockTitle: 'Pricing',
      blockText: 'Create unique menu with prices',
      blockShortText: 'Create unique menu',
      name: 'Name',
      nameTooltip: 'Enter name of your product',
      pricingPlanName: 'Pricing plan name',
      pricingPlanNameTooltip: 'Enter name of your pricing plan name',
      description: 'Description',
      descriptionTooltip: 'Enter description of your product',
      pricingPlanDescriptionTooltip: 'Enter description of your pricing plan',
      priceValue: 'Price value',
      priceUnit: 'Price unit',
      label: 'Label',
      labelTooltip: 'Enter label of your pricing plan',
      orderButtonText: 'Order button text',
      orderButtonTextDescriptionTooltip: 'Enter order button text of your pricing plan',
      orderButtonLink: 'Order button link',
      orderButtonLinkDescriptionTooltip: 'Enter order button link of your pricing plan',
      subtitle: 'Subtitle',
      subtitleTooltip: 'Enter subtitle of your product',
      price: 'Price',
      priceTooltip: 'Enter price of your product',
      pricingTiers: 'Pricing tiers',
      pricingTiersTooltip: 'Enter pricing tiers of your product',
      addPriceValue: 'Add more price',
      group: 'Group',
      groupTooltip: 'Choose group of your product',
      image: 'Image',
      imageTooltip: 'Upload image for your product',
      unit: 'Price unit',
      unitTooltip: 'Enter unit of your price',
      addUnitTitle: 'Price units',
      addPriceUnitValue: 'Add more price unit',
      addUnitButtonText: 'Save',
      button: 'Button',
      buttonTooltip: 'Add button for your product',
      buttonAddText: '+ Add button',
      buttonModalTextField: 'Button text',
      buttonModalTextFieldTooltip: 'Enter button text',
      buttonModalURLField: 'Button URL',
      buttonModalURLFieldTooltip: 'Enter button URL',
      buttonModalTitle: 'Add button',
      groups: {
        title: 'Groups',
        subtitle: 'Add, edit and delete groups',
        groups: 'Groups',
        groupsTooltip: 'Add, edit and delete groups',
        addNewGroup: 'Add new group',
        newGroup: 'New group',
        titleGroup: 'Title',
        titleGroupTooltip: 'Enter title of your group',
        descriptionGroup: 'Description',
        descriptionGroupTooltip: 'Enter description of your group',
      },
    },
    menuBlock: {
      title: 'Menu',
      subtitle: 'Create a menu with items and prices',
      add: 'Add new item',
      edit: 'Edit item',
      name: 'Name',
      nameCaption: 'Enter the item name',
      description: 'Description',
      descriptionCaption: 'Enter a short description',
      ingredients: 'Ingredients',
      ingredientsCaption: 'List ingredients or composition',
      price: 'Price',
      priceCaption: 'Enter the price',
      weight: 'Weight (g)',
      weightCaption: 'Enter the weight in grams',
      calories: 'Calories (kcal)',
      caloriesCaption: 'Enter calories in kcal',
      label: 'Label',
      labelCaption: 'Enter label text',
      labelColor: 'Label color',
      labelColorCaption: 'Choose a label background color',
      image: 'Image',
      imageCaption: 'Upload an image for your item',
      available: 'Available for ordering',
      visible: 'Visible on page',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Display an NFT from OpenSea platform or your personal wallet',
      blockShortText: 'Display an NFT',
    },
    wallet: {
      wallet: 'Wallet',
      blockTitle: 'Bank/Crypto Wallet',
      blockText: 'Display your Credit Card or Bitcoin wallet to make it easier for your users to copy it to transfer funds',
      blockShortText: 'Display your wallets',
      title: 'Title',
      titleTooltip: 'Title of your wallet',
      walletNumber: 'Wallet number',
      walletNumberTooltip: 'Paste your wallet number',
      icon: 'Icon',
      iconTooltip: 'Set icon for your wallet',
      card: 'Card',
      bank: 'Bank',
      crypto: 'Crypto',
      transfer: 'Transfer',
      paymentLink: 'Payment link',
      cardNumber: 'Card number',
      cardNumberTooltip: 'Paste your card number',
      cardHolder: 'Card holder',
      cardHolderTooltip: 'Enter your card holder',
      bankAccountDetails: 'Bank account details',
      bankAccountDetailsTooltip: 'Enter your bank account details',
      walletAddress: 'Wallet address',
      walletAddressTooltip: 'Enter your wallet address',
      network: 'Network',
      networkTooltip: 'Enter your network',
      publicKey: 'Public key',
      publicKeyTooltip: 'Enter your public key',
      providerName: 'Provider name',
      providerNameTooltip: 'Enter your provider name',
      link: 'Link',
      linkTooltip: 'Enter your link',
      serviceName: 'Service name',
      serviceNameTooltip: 'Enter your service name',
      email: 'Email',
      emailTooltip: 'Enter your email',
      phone: 'Phone',
      phoneTooltip: 'Enter your phone',
      username: 'Username',
      usernameTooltip: 'Enter your username',
      fullName: 'Full name',
      fullNameTooltip: 'Enter your full name',
      referenceNumber: 'Reference number',
      referenceNumberTooltip: 'Enter your reference number',
      country: 'Country',
      countryTooltip: 'Enter your country',
      transferProvider: 'Transfer provider',
      transferProviderTooltip: 'Enter your transfer provider',
      cryptoCurrency: 'Crypto Currency',
      cryptoCurrencyTooltip: 'Enter your crypto currency',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Feature your best Instagram media and video or sell your products with a shoppable Instagram feed',
      blockShortText: 'Your best Instagram media',
      blockConnectTitle: `Instagram isn't connected`,
      blockConnectText: "It seems like your Instagram products aren't imported yet. Connect your account now",
      blockConnectButton: 'Add Instagram',
      emptyList: 'You have no Instagram media yet.',
      addInstagramUsername: 'Add instagram username',
      username: 'Username',
      downloadTakes: 'Download takes up to 2 minutes',
      displayPost: 'Display post on your website',
      view: 'View',
      redirect: 'URL Redirect',
      text: 'Text & Button',
      actionType: 'Action type',
      url: 'URL',
      openInNewTab: 'Open in new tab',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      editMedia: 'Edit Media',
      title: 'Title',
      automation: 'Automation',
      automationText: 'Automate your account with Autopilot features',
      autopilot: 'Autopilot',
      autopilotTooltip: 'Upload a post with the sample caption and your product tags/ links will be automatically generated',
      switchTitle: 'Automatically detect title, price, links',
      sampleCaption: 'Sample caption: #49.99 #NiceDress https://google.com',
      integrations: 'Integrations',
      integrationsText: 'Add Instagram to your website',
      connectInstagram: 'Connect Instagram',
      connectInstagramText: 'Connect your Instagram account to display your choice of posts or reels.',
      selectAccount: 'Select account',
      connectNewInstagram: 'Connect a new Instagram account',
      continue: 'Continue',
      disconnectInstagram: 'Disconnect Instagram',

      addTag: 'Add tag',
      tagClickHint: 'Click on the image to place the tag',
      tagPositionSet: 'Position set. Fill in the details below.',
      tagTypeLink: 'Link',
      tagTypeProduct: 'Product',
      tagLabel: 'Label',
      tagSelectProduct: 'Select product',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Feature your best TikTok video or sell your products with a shoppable TikTok feed',
      blockShortText: 'Your best TikTok video',
      addTikTok: 'Add TikTok account',
      individualVideo: 'Individual video',
      videoCollection: 'Video collection',
      add: 'Add',
      blockConnectTitle: `TikTok isn't connected`,
      blockConnectText: "It seems like your TikTok products aren't imported yet. Connect your account now",
      blockConnectButton: 'Connect TikTok',
      enterUsername: 'Enter username',
      enterVideo: 'Enter a TikTok video URL',
      emptyList: 'You have no TikTok media yet.',
      editMedia: 'Edit Media',
      addTikTokVideo: 'Add TikTok video',
      displayPost: 'Display post on your website',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      integrations: 'Integrations',
      integrationsText: 'Add TikTok to your website',
      connectTikTok: 'Connect TikTok',
      disconnectTikTok: 'Disconnect TikTok',
      individualText: "You can't connect TitTok account to this type of block ('individual').",
      individualText2: 'Please, add single TikTok video instead.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Feature a YouTube video or stream on your page. Tag products on YouTube video',
      blockShortText: 'Feature a YouTube video',
      enterYouTubeLink: 'Enter YouTube URL',
      enterYouTubeLinkTooltip: 'Paste YouTube URL',
    },
    overview: {
      blockTitle: 'Overview',
      blockText: 'Feature a video or stream on your page. Tag products on video',
      blockShortText: 'Tag products on video',
    },
    video: {
      blockTitle: 'Video',
      blockText: 'Feature a video or stream on your page. Tag products on video',
      blockShortText: 'Feature a video',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Display your Tweets on your UniLink page to grow engagement',
      blockShortText: 'Display your Tweets',
      twitterURL: 'Twitter URL',
      twitterURLTooltip: 'Add URL from Twitter for generate embedded code',
      enterTwitterURL: 'Enter a Twitter URL',
    },
    music: {
      blockTitle: 'Music',
      blockText: 'Embed Spotify, SoundCloud song, playlist or upload your own audio file',
      blockShortText: 'Add your music',
      brand: 'Brand',
      brandTooltip: 'Choose type for adding your music',
      url: 'URL',
      embed: 'Embed code',
      custom: 'Custom',
      musicUrl: 'Music URL',
      musicUrlTooltip: 'Enter music URL',
      embedCodeTitle: 'Embed code',
      embedCodeTooltip: 'Paste embed code of your song from chosen music platform',
      audioFile: 'Audio file',
      uploadAudios: 'You can only upload audio here',
      title: 'Title',
      titleTooltip: 'Enter title of your music',
      artist: 'Artist',
      artistTooltip: 'Enter artist of your music',
      audioFileTitle: 'Audio file',
      audioFileTooltip: 'Name of your audio file',
      coverImage: 'Cover image',
      coverImageTooltip: 'Upload image for your music',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Embed Twitch video or stream on your page',
      blockShortText: 'Embed Twitch video',
      twitchURL: 'Twitch URL',
      twitchURLTooltip: 'Paste channel url or channel name',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Display my Twitch channel',
      displayChat: 'Display both my Twitch channel and chat',
    },
    splash: {
      blockTitle: 'Splash screen',
      blockText: 'Full screen banner with text and button appears before site loading to promote any product or event',
      blockShortText: 'Full screen banner',
    },
    promo: {
      blockTitle: 'Promo bar',
      blockText: 'Highlight that lets you appear promotions',
      blockShortText: 'Highlight your promotions',
    },
    welcome: {
      blockTitle: 'Welcome message',
      blockText: 'Write welcome messages that prompt visitors to start chatting. It pops up on the bottom of the page to welcome visitors and offer assistance',
      blockShortText: 'Write welcome messages',
    },
    review: {
      blockTitle: 'Reviews',
      blockText: 'Reviews help customers to learn more about the product and decide whether it is the right product for them',
      blockShortText: 'Reviews help customers',
      name: 'Name',
      nameTooltip: 'Enter reviewer name',
      comment: 'Comment',
      commentTooltip: 'Enter reviewer comment',
      date: 'Date',
      dateTooltip: 'Enter reviewer date',
      rate: 'Rage',
      rateTooltip: 'Set review rate',
      image: 'Image',
      imageTooltip: 'Upload reviewer image',
    },
    coupon: {
      blockTitle: 'Coupons',
      blockText: 'An online coupon refers to a discount code or number that can be redeemed on a website',
      blockShortText: 'Online coupon refers',
    },
    timer: {
      blockTitle: 'Timer',
      blockText: 'A countdown timer is a virtual clock on a page that counts down from a certain number or date to indicate the beginning or end of an event or offer',
      blockShortText: 'A countdown timer',
    },
    outfit: {
      blockTitle: 'Outfits',
      blockText: 'Create your own product list',
      blockShortText: 'Create product list',
    },
    spacer: {
      blockTitle: 'Spacer',
      blockText: 'Add some empty vertical space to your page',
      blockShortText: 'Add some empty',
    },
    html: {
      blockTitle: 'HTML code',
      blockText: 'You can paste your own HTML code to UniLink page. HTML is a standard markup language for web page creation. It allows iframes, sections, paragraphs, and links.',
      blockShortText: 'Paste your own HTML',
      markupCode: 'Markup code',
      markupCodeTooltip: 'Paste markup code of your HTML',
    },
    unlock: {
      blockTitle: 'Unlock',
      blockText: 'You can add your unlock content to UniLink page.',
      blockShortText: 'Paste your unlikable file',
    },
    file: {
      blockTitle: 'File',
      blockText: 'This block allows you to upload and share files such as documents, images, or audio. Visitors can easily view or download them directly from your page.',
      blockShortText: 'Upload and share your files.',
      addNewItem: 'Add new file',
      editFile: 'Edit FIle',
      fileName: 'Enter the file name',
    },
    stat: {
      blockTitle: 'Statistics',
      blockText:
        'This block allows you to display key insights about your page, such as views, visitors, or engagement. It helps you monitor your audience and understand how your page performs.',
      blockShortText: 'Add statistics to your page.',
      addNewItem: 'Add new statistic',
      editItem: 'Edit statistic',
      statName: 'Enter the statistic name',
      statValue: 'Enter the statistic value',
      statDescription: 'Enter the statistic description',
      statItemFields: 'Select fields to display.',
      feed: 'Feed',
      slider: 'Slider',
      titleSize: 'Title size',
      subtitleTitleSize: 'You can change title size',
    },
    listing: {
      blockTitle: 'Listing',
      blockText: 'Display property or item listings with images, details, and pricing.',
      blockShortText: 'Add listings to your page.',
    },
    rental: {
      blockTitle: 'Rental',
      blockText: 'List rental properties or items with availability and pricing per period.',
      blockShortText: 'Add rentals to your page.',
    },
    'single-product': {
      blockTitle: 'Single Product',
      blockText: 'Feature a single product with image, description, and buy button.',
      blockShortText: 'Feature a product.',
    },
    team: {
      blockTitle: 'Team',
      blockText: 'Introduce your team members with photos, names, roles, and social links.',
      blockShortText: 'Show your team.',
    },
    timetable: {
      blockTitle: 'Timetable',
      blockText: 'Display a weekly schedule with classes, events, or sessions.',
      blockShortText: 'Add a weekly schedule.',
    },
    'page-list': {
      blockTitle: 'Page List',
      blockText: 'Display a list of your pages with titles and descriptions for easy navigation.',
      blockShortText: 'List your pages.',
    },
    unlock: {
      blockTitle: 'Unlock',
      blockText: 'Gate content behind a password, email, payment, or custom rules. Perfect for exclusive content and paid access.',
      blockShortText: 'Lock content.',
    },
  },
};
